import { Controller } from "@hotwired/stimulus"
import { contains } from "jquery";
let debounce = require("lodash/debounce");

const OutcomeMeasure_NAMES = {
  'das28': 'DAS-28',
  'basdai_asdas': 'BASDAI & ASDAS',
  'sledai': 'SLEDAI',
  'essdai': 'ESSDAI',
  'fiq': 'FIQ',
  'modified_rodnan': 'Modified Rodnan Skin Score'
};

export default class extends Controller {
  static targets = ["queriesList"]

  // Class-level flag to track if listeners are already attached
  static listenersAttached = false;

  connect() {
    console.log("Prescription!")
    window.TOKEN = window.readCookie("_priac_jwt");
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.size > 0){
      setTimeout(() => {
        this.fillPatient(null)
        window.history.replaceState(null, '', window.location.pathname);
      }, 1000);
    }

    // Allied Notes button — delegated jQuery click bound once globally.
    // Stimulus action sometimes fails to fire on this button (likely due to
    // the absolute-positioned container intercepting events); delegation is
    // bulletproof regardless of DOM layering.
    if (!window._alliedNotesClickBound) {
      $(document).on('click', '#allied-notes-btn', (e) => this.openAlliedNotes(e));
      window._alliedNotesClickBound = true;
    }

    $(this.element).on('hidden.bs.modal', (event) => {
      // Remove the modal element that was just hidden
      const hiddenModal = event.target;
      if (hiddenModal) {
        $(hiddenModal).remove();
      }
      
      // Clean up leftover DYNAMIC modals only (those injected into .modal-container:
      // aiSummary, DAS-28, reports, etc.). Do NOT sweep every .modal on the page —
      // that deleted static modals like the generic panel's #prescriptionDetailsModal
      // (View Prescription), breaking it after the reports modal was closed.
      $('.modal-container .modal.fade').each(function() {
        if (!$(this).hasClass('show') && !$(this).is(':visible')) {
          $(this).remove();
        }
      });
      
      // Remove any leftover modal backdrops
      $('.modal-backdrop').remove();
      
      // Clean up body classes that might be stuck
      $('body').removeClass('modal-open');
    });

    // Initialize MediaRecorder
    this.mediaRecorder = null;
    this.audioChunks = [];
    this.attachRemarkPredictionListeners();
    
    // Initialize debounced search for all queries
    this.allQueriesSearchDebounced = null;
    
    // Initialize categories data
    this.patientCategories = [];
    this.allCategories = [];
    this.currentPatientId = null;
    this.categorySearchDebounced = null;

    // Initialize chatbot file upload and recording
    this.chatbotFiles = [];
    this.chatbotMediaRecorder = null;
    this.chatbotAudioChunks = [];
    this.chatbotIsRecording = false;
  }

  // loader(event){
  //   // Add Loader
  //   $(event.target).find('#save-blog').hide()
  //   $("#loader").html('<i class="fa fa-circle-o-notch"></i>')
  // }

  fillPatient(event){
    var block = this 
    const urlParams = new URLSearchParams(window.location.search);
    if (!event){
      var patientId = urlParams.get("patient_id")
      var appointmentId = urlParams.get("appointment_id")
    }else{
      var patientId = $(event.target).attr('data-patientid') 
      var appointmentId = $(event.target).attr('data-appointmentid')
    }

    $(".generic-report-data").html(null)

    if (!patientId){
      patientId = $(event.target).parents("td").attr('data-patientid');
    }
    if(!appointmentId){
      appointmentId = $(event.target).parents("td").attr('data-appointmentid');
    }

    handleSelect(patientId)

    // Show inline loaders on each section and clear stale data
    $(".investigations, .appts").html(null);
    $(`.treatment-table tbody`).html(null);
    showLoader($('.appointment-form'));
    showLoader($('.investigations-panel'));
    showLoader($('.diagnosis'));
    showLoader($('.treatment-table'));

    // Hide the auxiliary widgets during load so they don't sit there showing the
    // PREVIOUS patient's categories / videos / outcome measures behind the spinner.
    // Categories and outcome measures re-show themselves via their load functions
    // once the new data arrives; the static videos widget is re-shown after load.
    $('#patient-categories-container, #outcome-calculators-container, #videos-widget').hide();

    // Check for AI summary first
    block.checkAISummary(patientId, appointmentId, () => {
      // If no AI summary or after confirming AI summary, proceed with normal flow
      block.loadPatientData(patientId, appointmentId);
    });
  }

  checkAISummary(patientId, appointmentId, callback) {
    var block = this;
    
    // Check if AI summary exists for this appointment
    const url = appointmentId ? 
      `${HOST}/prescription/ai_summary?patient_id=${patientId}&appointment_id=${appointmentId}` :
      `${HOST}/prescription/ai_summary?patient_id=${patientId}`;
    
    $.ajax({
      url: url,
      headers: { "Authorization": `Token ${TOKEN}` },
      method: 'GET',
      success: function(summaryData) {
        if (summaryData && (summaryData.clinical_summary || summaryData.chiefComplaints || summaryData.clinicalStatus || summaryData.categorySummary || summaryData.clinicalImpression || summaryData.differentialDiagnosis)) {
          // Get patient information first
          $.ajax({
            url: `${HOST}/api/v1/patients/${patientId}`, 
            headers: { "Authorization": `Token ${TOKEN}` },
            success: function(patientRes) {
              const patientData = patientRes.payload;
              // AI summary exists, show the modal with patient data
              block.showAISummaryModal(summaryData, patientData, appointmentId, callback);
            },
            error: function() {
              // If patient data fails, still show modal without patient info
              block.showAISummaryModal(summaryData, null, appointmentId, callback);
            }
          });
        } else {
          // No AI summary for this appointment, proceed with normal flow
          callback();
        }
      },
      error: function() {
        // If AI summary service is not available or returns error, proceed with normal flow
        console.log('AI summary not available, proceeding with normal flow');
        callback();
      }
    });
  }

  showAISummaryModal(summaryData, patientData, appointmentId, callback) {
    var block = this;
    
    // Create the AI summary modal HTML
    var modalHtml = block.buildAISummaryModalHtml(summaryData, patientData);
    
    // If modalHtml is null (empty summary), skip the modal and proceed normally
    if (!modalHtml) {
      callback();
      return;
    }
    
    // Remove any existing AI summary modal
    $('#aiSummaryModal').remove();
    
    // Append the modal to body
    $(".modal-container").html(modalHtml);
    
    // Show the modal
    $('#aiSummaryModal').modal('show');

    // If modal is dismissed (X, backdrop, escape), still load patient data
    $('#aiSummaryModal').off('hidden.bs.modal').on('hidden.bs.modal', function() {
      if (callback) {
        callback();
        callback = null; // prevent double-fire if confirm also triggers
      }
    });

    // Store patientId and appointmentId on modal for print
    const currentPatientId = patientData?.id || $("#save_update, #saveprint").attr("data-patientId") || $(".quick-save").attr("data-patientid") || $('[data-patientid]').first().attr('data-patientid');
    // Prefer appointment_id from the summary data (authoritative) over the click-context value
    const currentAppointmentId = summaryData._appointment_id || appointmentId || '';
    $('#aiSummaryModal').attr('data-patient-id', currentPatientId);
    $('#aiSummaryModal').attr('data-appointment-id', currentAppointmentId);

    // Store specialist notes data on the modal for print access
    const specialistNotesData = summaryData.specialistNotes || [];
    $('#aiSummaryModal').data('specialistNotes', specialistNotesData);

    // Handle print button
    $('#aiSummaryModal .btn-print-summary').off('click').on('click', function() {
      const patientId = $('#aiSummaryModal').attr('data-patient-id');
      const apptId = $('#aiSummaryModal').attr('data-appointment-id');
      const printUrl = '/prescription/print_ai_summary';
      const notesData = $('#aiSummaryModal').data('specialistNotes') || [];

      // Collect only checked specialist notes with edited text from textareas
      const selectedNotes = [];
      $('#aiSummaryModal .specialist-note-print-check:checked').each(function() {
        const idx = parseInt($(this).data('index'));
        const editedNote = $(`#aiSummaryModal .ai-edit-specialist-note[data-index="${idx}"]`).val();
        if (idx < notesData.length) {
          selectedNotes.push({ department: notesData[idx].department, note: editedNote || notesData[idx].note });
        }
      });

      $.ajax({
        url: printUrl,
        method: 'GET',
        data: { patient_id: patientId, appointment_id: apptId, specialist_notes_override: JSON.stringify(selectedNotes) },
        success: function(data) { if (data.content) window.printPage(data.content); },
        error: function() { flashToast('Error printing summary', 'warning'); }
      });
    });

    // Handle confirm button click — save all edits then proceed
    $('#aiSummaryModal .btn-confirm').off('click').on('click', function() {
      // Use appointment_id from summary data (authoritative) — fallback to closure
      const effectiveAppointmentId = summaryData._appointment_id || appointmentId;
      if (effectiveAppointmentId) {
        // Collect all edited fields
        const editedData = {};

        // Chief complaints
        const chiefComplaint = $('#ai-edit-chief-complaint').val();
        if (chiefComplaint !== undefined) editedData.chiefComplaints = chiefComplaint;

        // Clinical impression
        const impression = $('#ai-edit-clinical-impression').val();
        if (impression !== undefined) editedData.clinicalImpression = impression;

        // Clinical status fields
        const clinicalStatus = {};
        $('.ai-edit-field[data-section="clinicalStatus"]').each(function() {
          clinicalStatus[$(this).data('key')] = $(this).val();
        });
        if (Object.keys(clinicalStatus).length > 0) editedData.clinicalStatus = clinicalStatus;

        // Holistic dashboard fields
        const holistic = {};
        $('.ai-edit-field[data-section="holisticDashboard"]').each(function() {
          holistic[$(this).data('key')] = $(this).val();
        });
        if (Object.keys(holistic).length > 0) editedData.holisticDashboard = holistic;

        // Red flags
        const redFlagsVal = $('#ai-edit-red-flags').val();
        if (redFlagsVal !== undefined) {
          editedData.redFlagsDetected = redFlagsVal.split(';').map(s => s.trim()).filter(s => s);
        }

        // Referrals
        const referrals = [];
        $('.ai-edit-referral').each(function() {
          const val = $(this).val().trim();
          if (val) referrals.push(val);
        });
        if (referrals.length > 0) editedData.alliedReferrals = referrals;

        // Old format fields
        const history = $('#ai-edit-history').val();
        if (history !== undefined) editedData.history_of_present_illness = history;
        const symptoms = $('#ai-edit-symptoms').val();
        if (symptoms !== undefined) editedData.identified_symptoms = symptoms;

        // Collect edited specialist notes
        const specialistNotes = [];
        $('.ai-edit-specialist-note').each(function() {
          const reportId = $(this).data('report-id');
          const newNote = $(this).val();
          if (reportId && newNote !== undefined) {
            specialistNotes.push({ id: reportId, note: newNote });
          }
        });
        if (specialistNotes.length > 0) editedData.specialist_notes = specialistNotes;

        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        $.ajax({
          url: `/prescription/update_ai_summary`,
          method: 'PATCH',
          contentType: 'application/json',
          headers: { 'X-CSRF-Token': csrfToken },
          data: JSON.stringify({ appointment_id: effectiveAppointmentId, ...editedData }),
          success: function() { console.log('AI summary updated successfully'); },
          error: function(err) { console.error('Failed to update AI summary:', err); }
        });
      }

      $('#aiSummaryModal').modal('hide');
      if (callback) callback();
    });
  }


  buildAISummaryModalHtml(summaryData, patientData) {
    // Handle both old format (clinical_summary) and new format (chiefComplaints, clinicalStatus, etc.)
    const isOldFormat = !!summaryData.clinical_summary;

    // Extract data from whichever format
    const chiefComplaints = isOldFormat
      ? (summaryData.clinical_summary?.chief_complaint || '')
      : (summaryData.chiefComplaints || '');

    const clinicalImpression = summaryData.clinicalImpression || summaryData.differentialDiagnosis || '';
    const clinicalStatus = summaryData.clinicalStatus || summaryData.categorySummary || {};
    const holistic = summaryData.holisticDashboard || {};
    const redFlags = summaryData.redFlagsDetected || [];
    const specialistNotes = summaryData.specialistNotes || [];
    const referrals = summaryData.alliedReferrals || [];

    // Old format fields
    const historyOld = isOldFormat ? (summaryData.clinical_summary?.history_of_present_illness || '') : '';
    const diagnosisOld = isOldFormat ? (summaryData.diagnosis?.provisional_diagnosis || '') : '';
    const symptomsOld = isOldFormat ? (summaryData.diagnosis?.identified_symptoms || []) : [];

    // Check if there's any content
    const hasContent = chiefComplaints || clinicalImpression || Object.keys(clinicalStatus).length > 0 || historyOld || diagnosisOld;
    if (!hasContent) return null;

    const patientInfo = patientData ? {
      uid: patientData.uid || 'N/A',
      fullName: patientData.full_name || 'Unknown Patient'
    } : { uid: 'N/A', fullName: 'Unknown Patient' };

    // Build editable clinical status rows
    const statusLabels = {
      globalHealth: 'Global Health', painSummary: 'Pain Summary', diseaseActivity: 'Disease Activity',
      functionalImpact: 'Functional Impact', compliance: 'Compliance',
      jointPath: 'Joint Assessment', systemic: 'Systemic', gut: 'Gut', psych: 'Psychological', ayurvedic: 'Ayurvedic',
      currentMedications: 'Current Medications', otherMedications: 'Other Medications',
      pastMedicalHistory: 'Past Medical History', previousTestsTreatment: 'Previous Tests & Treatment',
      patientPerspective: 'Patient Perspective (ICE)'
    };
    let clinicalStatusHtml = '';
    for (const [key, value] of Object.entries(clinicalStatus)) {
      if (value && typeof value === 'string' && value.trim()) {
        const label = statusLabels[key] || key.replace(/([A-Z])/g, ' $1').trim();
        clinicalStatusHtml += `<div class="mb-2"><small class="text-uppercase font-weight-bold text-muted">${label}</small><textarea class="form-control mt-1 ai-edit-field" data-section="clinicalStatus" data-key="${key}" rows="3">${value}</textarea></div>`;
      }
    }

    // Build editable holistic rows
    const holisticLabels = {
      sleepRoutine: 'Sleep Routine', dietHabits: 'Diet & Habits', stressLifeEvents: 'Stress & Life Events',
      wellbeingSnapshot: 'Wellbeing Snapshot', substanceUse: 'Substance Use'
    };
    let holisticHtml = '';
    for (const [key, value] of Object.entries(holistic)) {
      if (value && typeof value === 'string' && value.trim()) {
        const label = holisticLabels[key] || key.replace(/([A-Z])/g, ' $1').trim();
        holisticHtml += `<div class="mb-2"><small class="text-uppercase font-weight-bold text-muted">${label}</small><textarea class="form-control mt-1 ai-edit-field" data-section="holisticDashboard" data-key="${key}" rows="3">${value}</textarea></div>`;
      }
    }

    // Red flags HTML
    let redFlagsHtml = '';
    if (redFlags.length > 0) {
      redFlagsHtml = `<div class="alert alert-danger py-2 mb-3"><strong><i class="fa fa-exclamation-triangle mr-1"></i>Red Flags:</strong><ul class="mb-0 mt-1">${redFlags.map(f => `<li>${f}</li>`).join('')}</ul></div>`;
    }

    // Referrals HTML — extract department names only
    let referralsHtml = '';
    if (referrals.length > 0) {
      const knownDepts = ['Physiotherapist', 'Dietitian', 'Psychologist', 'Ayurvedic', 'Ophthalmologist', 'Dermatologist', 'Cardiologist', 'Nephrologist', 'Neurologist', 'Pulmonologist'];
      const deptAliases = { 'yoga expert': 'Yoga / Wellness' };
      const extractedDepts = [];
      referrals.forEach(r => {
        const rLower = r.toLowerCase();
        // Check aliases first (e.g., "yoga expert" → "Yoga / Wellness")
        const aliasKey = Object.keys(deptAliases).find(a => rLower.includes(a));
        if (aliasKey) { extractedDepts.push(deptAliases[aliasKey]); return; }
        const found = knownDepts.find(d => rLower.includes(d.toLowerCase()));
        if (found) extractedDepts.push(found);
      });
      const badges = extractedDepts.map(d => `<span class="badge badge-info px-3 py-2 mr-2 mb-1" style="font-size: 0.9rem;">${d}</span>`).join('');
      referralsHtml = `
        <div class="mb-3">
          <small class="text-uppercase font-weight-bold text-muted"><i class="fa fa-share mr-1"></i>Suggested Referrals</small>
          <div class="mt-2">${badges}</div>
        </div>`;
    }

    // Extract VAS pain score
    let vasScore = null;
    const painText = clinicalStatus.painSummary || clinicalStatus.globalHealth || '';
    const vasMatch = painText.match(/(\d+)\s*\/\s*10/);
    if (vasMatch) vasScore = parseInt(vasMatch[1]);
    const vasColor = vasScore !== null ? (vasScore <= 3 ? '#4caf50' : vasScore <= 6 ? '#e65100' : '#c62828') : null;
    const vasLabel = vasScore !== null ? (vasScore <= 3 ? 'Mild' : vasScore <= 6 ? 'Moderate' : 'Severe') : '';

    return `
      <style>
        #aiSummaryModal .modal-body { max-height: 80vh; overflow-y: auto; padding: 20px 24px; }
        #aiSummaryModal textarea.form-control { font-size: 1rem !important; line-height: 1.6; overflow: hidden; resize: none; border: 1px solid #ddd; }
        #aiSummaryModal .form-control { font-size: 1rem !important; }
        #aiSummaryModal .section-title { font-size: 1.05rem; font-weight: 700; color: #C9A84C; margin: 18px 0 10px; padding-bottom: 4px; border-bottom: 1px solid #eee; }
        #aiSummaryModal .field-label { font-size: 0.75rem; text-transform: uppercase; font-weight: 700; color: #999; margin-bottom: 3px; }
      </style>
      <script>
        setTimeout(function() {
          $('#aiSummaryModal textarea').each(function() {
            this.style.height = 'auto';
            this.style.height = (this.scrollHeight + 4) + 'px';
          }).on('input', function() {
            this.style.height = 'auto';
            this.style.height = (this.scrollHeight + 4) + 'px';
          });
        }, 300);
      </script>
      <div class="modal fade" id="aiSummaryModal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content border-0 shadow">
            <div class="modal-header" style="background: #C9A84C; padding: 14px 24px;">
              <div>
                <span style="font-size: 1.2rem; font-weight: 700; color: white;">Intelligence Summary</span>
                <span style="color: rgba(255,255,255,0.8); margin-left: 15px; font-size: 0.95rem;">${patientInfo.fullName} (${patientInfo.uid})</span>
              </div>
              <div>
                <button type="button" class="btn btn-sm btn-light btn-print-summary mr-2" style="font-size: 0.8rem;">
                  <i class="fa fa-print"></i> Print
                </button>
                <button type="button" class="close text-white" data-dismiss="modal"><span>&times;</span></button>
              </div>
            </div>
            <div class="modal-body">

              ${redFlags.length > 0 ? `<div style="background: #fff3f3; border: 1px solid #ffcdd2; border-radius: 6px; padding: 8px 14px; margin-bottom: 14px;">
                <div style="font-size:0.75rem;font-weight:700;color:#c62828;text-transform:uppercase;margin-bottom:4px;"><i class="fa fa-exclamation-triangle mr-1"></i>Red Flags</div>
                <textarea id="ai-edit-red-flags" class="form-control" rows="2" style="font-size:0.9rem;border:1px solid #ffcdd2;background:#fff;color:#c62828;">${redFlags.join('; ')}</textarea>
              </div>` : ''}

              ${vasScore !== null ? `
              <div style="display: flex; align-items: center; margin-bottom: 14px; padding: 8px 14px; background: #fafafa; border-radius: 4px; border: 1px solid #eee;">
                <span style="font-size: 0.9rem; font-weight: 600; color: #555;">VAS Pain Score</span>
                <span style="font-size: 1.4rem; font-weight: 700; color: ${vasColor}; margin-left: 12px;">${vasScore}/10</span>
                <span style="font-size: 0.8rem; font-weight: 600; color: ${vasColor}; margin-left: 8px;">${vasLabel}</span>
              </div>` : ''}

              ${chiefComplaints ? `
              <div class="field-label">Chief Complaints</div>
              <textarea id="ai-edit-chief-complaint" class="form-control mb-3" rows="2">${chiefComplaints}</textarea>` : ''}

              ${clinicalImpression ? `
              <div class="field-label">Clinical Impression <span style="font-weight: 400; text-transform: none; color: #bbb;">(not printed)</span></div>
              <textarea id="ai-edit-clinical-impression" class="form-control mb-3" rows="4">${clinicalImpression}</textarea>` : ''}

              ${clinicalStatusHtml ? `
              <div class="row">
                <div class="col-md-${holisticHtml ? '6' : '12'}">
                  <div class="section-title">Clinical Status</div>
                  ${clinicalStatusHtml}
                </div>
                ${holisticHtml ? `
                <div class="col-md-6">
                  <div class="section-title">Lifestyle & Wellbeing</div>
                  ${holisticHtml}
                </div>` : ''}
              </div>` : ''}

              ${isOldFormat ? `
              <div class="row">
                <div class="col-md-6">
                  <div class="section-title">Clinical Summary</div>
                  <div class="field-label">History of Present Illness</div>
                  <textarea id="ai-edit-history" class="form-control mb-3" rows="4">${historyOld}</textarea>
                </div>
                <div class="col-md-6">
                  <div class="section-title">Diagnosis</div>
                  ${diagnosisOld ? `<div class="field-label">Provisional Diagnosis</div><textarea class="form-control mb-3" rows="2">${diagnosisOld}</textarea>` : ''}
                  ${symptomsOld.length > 0 ? `<div class="field-label">Identified Symptoms</div><input id="ai-edit-symptoms" type="text" class="form-control mb-3" value="${symptomsOld.join(', ')}">` : ''}
                </div>
              </div>` : ''}

              ${(() => {
                // PERMA-H Chart
                const wsText = holistic.wellbeingSnapshot || '';
                if (!wsText || ['Not assessed', 'Not reported', 'Not answered'].includes(wsText.trim())) return '';

                const extract = (pattern) => { const m = wsText.match(pattern); return m ? parseInt(m[1]) : null; };
                const permaScores = {
                  P: extract(/(?:joy|peace|happy)[^0-9]*(\d+)/i),
                  E: extract(/(?:engag|interested|involved)[^0-9]*(\d+)/i),
                  R: extract(/(?:support|connect)[^0-9]*(\d+)/i),
                  M: extract(/(?:meaning|purpose)[^0-9]*(\d+)/i),
                  A: extract(/(?:confiden|accomplish)[^0-9]*(\d+)/i),
                  H: extract(/(?:health habit|satisfied with health)[^0-9]*(\d+)/i)
                };
                const valid = Object.entries(permaScores).filter(([,v]) => v !== null);
                if (valid.length === 0 || !valid.some(([,v]) => v > 0)) return '';

                const colors = { P: '#e74c3c', E: '#f39c12', R: '#2ecc71', M: '#3498db', A: '#9b59b6', H: '#1abc9c' };
                const labels = { P: 'Positive', E: 'Engage', R: 'Relation', M: 'Meaning', A: 'Accomplish', H: 'Health' };
                const mean = (valid.reduce((s, [,v]) => s + v, 0) / valid.length).toFixed(1);

                const bars = valid.map(([k, v]) => `
                  <div style="display:flex; flex-direction:column; align-items:center; flex:1;">
                    <span style="font-size:11px; font-weight:600; color:#4a5568; margin-bottom:3px;">${v}</span>
                    <div style="width:100%; max-width:40px; height:${v * 14}px; background:${colors[k]}; border-radius:3px 3px 0 0;"></div>
                    <span style="font-size:13px; font-weight:700; color:${colors[k]}; margin-top:4px;">${k}</span>
                    <span style="font-size:8px; color:#a0aec0;">${labels[k]}</span>
                  </div>`).join('');

                return `
                  <div style="margin-top:14px; padding:14px 18px; background:#fafafa; border:1px solid #eee; border-radius:6px;">
                    <div class="section-title" style="margin-top:0;">Wellbeing Profile <span style="float:right; font-size:12px; color:#718096; font-weight:500;">Mean: ${mean}/10</span></div>
                    <div style="display:flex; align-items:flex-end; justify-content:center; gap:10px; height:170px; padding-top:10px;">
                      ${bars}
                    </div>
                  </div>`;
              })()}

              ${specialistNotes.length > 0 ? `
              <div style="margin-top:14px;">
                <div class="section-title">Specialist Notes</div>
                ${specialistNotes.map((n, i) => `
                  <div style="padding:8px 14px; background:#fafafa; border:1px solid #eee; border-radius:4px; margin-bottom:6px;">
                    <div style="display:flex; justify-content:space-between; align-items:center;">
                      <div style="font-size:0.8rem; font-weight:600; color:#1E9BB7;">${n.department} <span style="font-weight:400; color:#94a3b8;">— ${n.specialist}</span></div>
                      <label style="font-size:0.75rem; color:#64748b; margin:0; cursor:pointer;"><input type="checkbox" class="specialist-note-print-check" data-index="${i}" checked style="margin-right:4px;"> Include in print</label>
                    </div>
                    <textarea class="form-control mt-1 ai-edit-specialist-note" data-index="${i}" data-report-id="${n.id}" rows="2" style="font-size:0.85rem;">${n.note}</textarea>
                  </div>`).join('')}
              </div>` : ''}

              ${referrals.length > 0 ? (() => {
                const knownDepts = ['Physiotherapist', 'Dietitian', 'Psychologist', 'Ayurvedic', 'Ophthalmologist', 'Dermatologist', 'Cardiologist', 'Nephrologist', 'Neurologist', 'Pulmonologist'];
                const deptAliases = { 'yoga expert': 'Yoga / Wellness' };
                const extracted = [];
                referrals.forEach(r => {
                  const rL = r.toLowerCase();
                  const ak = Object.keys(deptAliases).find(a => rL.includes(a));
                  if (ak) { extracted.push(deptAliases[ak]); return; }
                  const f = knownDepts.find(d => rL.includes(d.toLowerCase()));
                  if (f) extracted.push(f);
                });
                return extracted.length > 0 ? '<div class="field-label mt-3">Suggested Referrals</div><div class="mb-3">' + extracted.map(d => '<span style="display:inline-block; padding: 4px 12px; margin: 2px 4px 2px 0; background: #f5f5f5; border: 1px solid #ddd; border-radius: 3px; font-size: 0.85rem; color: #555;">' + d + '</span>').join('') + '</div>' : '';
              })() : ''}

              <p class="text-center mt-2 mb-0" style="font-size: 0.8rem; color: #bbb;">
                This automated summary is for reference only. Clinical judgment should always take precedence.
              </p>

            </div>
            <div class="modal-footer" style="padding: 10px 24px; border-top: 1px solid #eee;">
              <button type="button" class="btn btn-confirm px-4 py-2" style="background: #C9A84C; color: white; border: none; border-radius: 6px; font-weight: 500;">
                <i class="fa fa-check mr-1"></i> Save & Start Consultation
              </button>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  loadPatientData(patientId, appointmentId) {
    var block = this;
    $.ajax({
      url:  `${HOST}/api/v1/patients/${patientId}`, 
      headers: { "Authorization": `Token ${TOKEN}` },
      success: function(res){
        var patientParams = res.payload

        // Reset prints buttons
        $("#save_update, #saveprint, #create_visit").show()
        $("#prescription_reprint").attr("data-prescriptionid", null).addClass("d-none")

        $("tr").removeClass("bg-olive");
        $("#upload-audio, .recording-btn, #audio-preview, #show-ir-samples").hide();

        fillPatientData(patientParams)
        createAppointmentTabs(res)
        $("#save_update, #saveprint, .update-patient-info").attr("data-patientId", patientId)
        $("#save_update, #saveprint").attr("data-appointmentid", appointmentId)
        
        // Load patient categories
        block.loadPatientCategories(patientId)
        console.log("load categories")

        // Load DAS28 calculator and latest score
        block.loadDas28Calculator(patientId)

        // Re-evaluate the videos widget now that the patient's data has loaded
        // (hidden at load start). It only shows if the "Videos" checkbox is on.
        if (typeof window.syncVideosWidget === "function") window.syncVideosWidget();

        // Get today's appointment data
        var appointment = res.payload.appointments.filter(m => 
            (m.id == appointmentId) || 
            (m.status == "completed") || 
            (m.prescription_id != null && m.status == "paid")
        )[0]

        if (!appointment) {
          // No appointment found — hide all loaders
          hideLoader($('.appointment-form'));
          hideLoader($('.investigations-panel'));
          hideLoader($('.diagnosis'));
          hideLoader($('.treatment-table'));
        }

        if (appointment){
            // Fill Appointment Fields
            for (const k in appointment) {
            var apptVal = appointment[k] || "";
            var $apptElement = $(`#appointment_${k}`)
            
            if(!$($apptElement).is("select")){
              $(`input[name="appointment[${k}]"]`).val(apptVal)
            }else if ($apptElement.is(":checkbox")){
              $(`#appointment_${k}`).prop('checked', apptVal);
            }
            else if(k.indexOf("_id") == -1){
              $(`button[data-id='appointment_${k}']`).trigger("click")
              $(`button[data-id='appointment_${k}']`)
                .next(".dropdown-menu")
                .find(`span:contains(${ humanize(apptVal) })`)
                .parent().trigger("click")
            }else{
              $(`#appointment_${k}`).val(apptVal).trigger('change')
              // selectDropdownById(`appointment_${k}`, apptVal)
            }
            if (["tobacco", "alcohol", "smoking"].indexOf(k) != -1){
              $(`#appointment_${k}`).prop('checked', apptVal);
            }
          }

          // After filling all appointment fields, handle referrer fallback
          var appointmentReferrerId = appointment.referrer_id;
          var patientReferrerId = $("#patient_referrer_id").val();
          if (!appointmentReferrerId || appointmentReferrerId === "" || appointmentReferrerId === null || appointmentReferrerId === undefined) {
            appointmentReferrerId = patientReferrerId;
          }
          if (appointmentReferrerId) {
            $("#appointment_referrer_id").val(appointmentReferrerId).trigger("change");
          }

          // Appointment fields loaded
          hideLoader($('.appointment-form'));

          // Fill Investigations by getting the full appointment details
          $.ajax({
            url: `${HOST}/api/v1/appointments/${appointment.id}`,
            headers: { "Authorization": `Token ${TOKEN}` },
            success:  function(res){
              
              // Get list of all investigations to populate dropdown
              $.ajax({
                url: "/prescription/investigations",
                headers: { "Authorization": `Token ${TOKEN}` },
                success: function(r){
                  var options = '';
                  for (let index = 0; index < r.investigations.length; index++) {
                    const element = r.investigations[index];
                    options += `<option value='${element}'>${element}</option>`                    
                  }
                  $(`#medical_param`).empty('')
                  $(`#medical_param`).html(options).trigger("change")
                  newInvestigations(res.payload.ready_investigations, res.payload.id)
                  $(".investigations-panel").show()
                  hideLoader($('.investigations-panel'));
                }
              })

              // Show IR Sample Button
              if (res.payload.ir_samples.length > 0){
                $("#show-ir-samples").attr('href', `/prescription/show_samples?appointment_id=${res.payload.id}`).show()
              }else{
                $("#show-ir-samples").attr('ahref', null).hide()
              }
            }
          })
        }

        // If today's appointment is present and also the prescription is there then load the prescription data
        var onPrescriptionLoaded = function() {
          hideLoader($('.diagnosis'));
          hideLoader($('.treatment-table'));
        };

        if (appointment && appointment.prescription_id){
          block.getPrescription(appointment, onPrescriptionLoaded)
        }else{
          // Check and Carry forward last completed prescription data for today's appointment case
          var completedAppointment = res.payload.appointments.filter(m => (m.status == "completed" || (m.prescription_id != null && m.status == "paid")))[0]

          // if the completd visit is of today's date
          if (completedAppointment?.visit_date == (new Date()).toISOString().split('T')[0]){
            appointment = completedAppointment
          }

          if (completedAppointment){
            block.getPrescription(completedAppointment, onPrescriptionLoaded)
          }else{
            fillPrescriptionData(null)
            onPrescriptionLoaded();
          }
        }

        $("#save_update, #saveprint").attr("data-appointmentid", appointment?.id || null);
        $("#save_update, #saveprint").attr("data-prescriptionid", appointment?.prescription_id || null);
        $('input[audio_appointment_id]').val(appointment?.id);
        $(".recording-btn").show();
        $(event.target).parents('tr').addClass("bg-olive");
        
        // If searched another visit from top that is not of today's date then allow only reprint
        // debugger
        // if (!(appointment?.id || null)){
        //   $("#save_update, #saveprint").hide()
        //   $("#prescription_reprint").attr("data-prescriptionid", completedAppointment?.prescription_id || null).removeClass("d-none")
        // }

        // Load Generic Panel
        $.ajax({
          url:  `${HOST}/prescription/get_report?appointment_id=${appointment.id}`,
          headers: { "Authorization": `Token ${TOKEN}` },
          success: function(res){},
          error: function(err){
          }
        })

        // Load allied specialist notes count + cache reports for modal
        block.loadAlliedNotes(appointment.id);

        // Auto-open enquiry thread if patient has open enquiries
        block.autoOpenPatientEnquiry(patientId);
      }
    })
  }

  autoOpenPatientEnquiry(patientId) {
    const HOST = window.location.origin;
    const TOKEN = window.TOKEN || window.readCookie("_priac_jwt");
    const block = this;

    // Check if patient has any query (open, in_progress, or resolved)
    fetch(`${HOST}/prescription/query_messages?patient_id=${patientId}`, {
      headers: { "Authorization": `Token ${TOKEN}` }
    })
      .then(response => response.json())
      .then(data => {
        if (data.messages && data.messages.length > 0) {
          const chatWindow = $('#chatbot-window');
          if (!chatWindow.is(':visible')) {
            chatWindow.show();
          }
          block.showChatbotChat(null, patientId);
        }
      })
      .catch(err => console.error('Auto-open enquiry check failed:', err));
  }
  
  getPrescription(appt, onComplete){
    $(".show_reports").attr("href", `/prescription/medical_reports?patient_id=${appt.patient_id}`)

    var prescriptionId = appt.prescription_id;

    // Clean the table
    $(`.treatment-table tbody`).html(null);

    // Fill prescription data of past completed appointment
    if (prescriptionId){
      fillPrescriptionData(prescriptionId, onComplete)
      $("#show-summary").attr("href", "/prescription/show_summary?prescription_id=" + prescriptionId)
      
      // $.ajax({
      //   url:  `${HOST}/prescription/load_predictions?appointment_id=${appt.id}`, 
      //   headers: { "Authorization": `Token ${TOKEN}` },
      //   success: function(res){
      //     let predictionsHtml = '';
      //     for (const [medicine, probability] of Object.entries(res.predictions)) {
      //       const percentage = (probability * 100).toFixed(2); // Convert to percentage
      //       predictionsHtml += `<h6>${medicine}: ${percentage}%</h6>`;
      //     }
      //     $('.predictions').html(predictionsHtml);
      //   },
      //   error: function(err){
      //     console.log(err)
      //   }
      // })

      // $("#save_update, #saveprint").attr("data-prescriptionid", prescriptionId);
    }else{
      fillPrescriptionData(null)
      if (onComplete) onComplete();
    }

    // Fill the ids or futther processing
    $("#patient-consultancy").removeClass('d-none').text(`Consultancy: ${appt.consultancy}`)

    $(".medicalTestsList").html(null)
  }

  getMedicalTest(event){
    var name = $(event.target).val()
    $.ajax({
      url: `/api/v1/medical_tests/show_by_name?name=${name}`,
      headers: { "Authorization": `Token ${TOKEN}` },
      success: function(res){
        console.log(res)
        $("#medical_code").text(res.payload.code)
        $("#medical_cost").text(res.payload.amount)
        $("#generated_at").text(new Date().toLocaleDateString())
        $("#female_minmax").append( `${res.payload.female_min || ''} - ${res.payload.female_max || ''}`)
        $("#male_minmax").append( `${res.payload.male_min || ''} - ${res.payload.male_max || ''}`)
        $(`#medical_test_id`).val(res.payload.id)
      },
      error: function(err){
        console.log(err)
      } 
    })
  }


  reportSave(event){
    var $form = $(event.target);
    var data = {
      medical_test_report: {
        medical_test_id: $form.find(`#medical_test_id`).val(),
        patient_id: $form.find(`#patient_id`).val(),
        medical_test_category_id: $form.parents("tr").find(`#medical_test_category_id`).val(),
        value: $form.find(`#value`).val()
      }
    }
    $.ajax({ 
      url:`/api/v1/medical_test_reports/`,
      headers: { "Authorization": `Token ${TOKEN}` },
      method: "POST",
      data: data,
      success: function(res){
        console.log(res)
        flashToast("Report Value Saved", "info")
      },
      error: function(res){
        console.log(res)
        flashToast("Test Not Exist", "warning")
      }
    });
  }

  addMedicalParam(event){
    var param = $(event.target).val()
    var fields = `
    <div data-test="${param.toUpperCase()}">
      <i class="text-danger fa fa-times" data-action="click->prescription#removeInvestigation"> 
      </i>
      <label class="display-7"> ${param} </label>
      <div class="d-flex mr-3">
        <div class="small-field">
          <input type="text" name="investigation[before_${param.toLowerCase()}]" id="before_${param.toLowerCase()}" class="form-control" placeholder="Before ${param}">
        </div>
        <div class="small-field">
          <input type="text" name="investigation[after_${param.toLowerCase()}]" id="${param.toLowerCase()}" class="form-control" placeholder="${param}">
        </div>
      </div>
    </div>`
    $(`.investigations`).append(fields)
    $(`#medical_param option[value='${param}']`).remove()
    $('#medical_param').selectpicker('refresh');
  }

  fillSpecialInstructions(event){
    event.preventDefault();
    $.get({
      url: `${HOST}/api/v1/prescriptions/special_instructions?code=${event.target.text}`, 
      headers: { "Authorization": `Token ${TOKEN}` },
      success: function(res){
        console.log(res)
        // $(event.target).hide()
        let oldValue = $("#prescription_special_instructions_").val()
                  .split(",")
                  .map(item => item.trim());
          oldValue.push(res.payload.value)
          var inst = [...new Set(oldValue)];
          console.log(inst)
        $("#prescription_special_instructions_").val( `${inst.join(", ")}`)
      }
    })
  }

  fillTests(event){
    event.preventDefault();
    $.ajax({
      url: `${HOST}/api/v1/medical_tests?shortcode=${event.target.text}`, 
      headers: { "Authorization": `Token ${TOKEN}` },
      success: function(res){
        console.log(res)
        var oldValue = $("#prescription_medical_tests_")
                .val()
        if (oldValue){
          oldValue = oldValue.split(",")
                .map(item => item.trim());
        }else {
          oldValue = []
        }
        var data = res.payload.medical_tests;
        for (let index = 0; index < data.length; index++) {
          if (data[index].name){
            oldValue.push(data[index].name)
          }
        }
        var tests = [...new Set(oldValue)];
        console.log(tests)
        $("#prescription_medical_tests_").val(`${tests.join(", ")}`)
      }
    })
  }

  removeMedicine(event){
    $(event.target).parents("tr")[0].remove()
  }

  dump(event){
    let input = $(event.target).parent().prev().find("input[type='text']")
    $(event.target).parent().find("li").removeClass("selected")
    $(event.target).addClass("selected")
    window.selectOption(input)
  }

  selectOption(event){
    let input = $(event.target).parent().prev().find("textarea")
    $(event.target).parent().find("li").removeClass("selected")
    $(event.target).addClass("selected")
    window.selectOption(input)
  }

  medicalTestsList(event) {
    // Clear the previous debounce timer if it exists
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    // Set a new debounce timer for 500ms
    this.debounceTimer = setTimeout(() => {
      this.performMedicalTestsList(event);
    }, 500);
  }

  performMedicalTestsList(event) {

    var list = $(event.target).parent().next(".medicalTestsList")
    if (event.target.value == ''){
      list.hide()
      list.html(null);
      return;
    }
    
    var query = event.target.value.split(",").pop().trim().toLowerCase()
    
    var html = '';
    const allTests = JSON.parse($(".all-medicaltests").text());
  
    const tests = allTests.filter(function(r){
      return r.name.toLowerCase().startsWith(query) || r.code.toLowerCase().startsWith(query) 
    }).sort((a, b) => a.name.length - b.name.length).splice(0, 10)

    if (tests.length == 0){
      list.hide()
      list.html(null);
      return;
    }

    for (let index = 0; index < tests.length; index++) {
      let med = tests[index];
      if (index == 0){
        var selected = 'selected';
      }else{
        var selected = '';
      }
      var matched_name = med.name
      html += `<li class="med ${selected} p-2" data-action="click->prescription#selectOption"> 
        ${matched_name}
      </li>`;
    }
    list.show()
    list.html( html )
  }


  followUpList(event){
    var list = $(event.target).parent().next(".followUpList")
    if (event.target.value == ''){
      list.hide()
      list.html(null);
      return;
    }
    var query = event.target.value.split(",").pop().trim()
    $.ajax({
      url: `${HOST}/api/v1/medicines/followup?q=${query}`, 
      headers: { "Authorization": `Token ${TOKEN}` },
      success: function(res){
        console.log(res)
        var html = '';
        // var tests = res.payload.medical_tests;
        var tests = res.payload.followups;
        for (let index = 0; index < tests.length; index++) {
          let med = tests[index];
          if (index == 0){
            var selected = 'selected';
          }else{
            var selected = '';
          }
          var matched_name = med
          html += `<li class="med ${selected} p-2" data-action="click->prescription#selectOption"> 
            ${matched_name}
          </li>`;
        }
        list.show()
        list.html( html )
      }
    })
  }

  videosList(event){
    var list = $(event.target).parent().next(".videosList")
    if (event.target.value == ''){
      list.hide()
      list.html(null);
      return;
    }
    var query = event.target.value.split(",").pop().trim()
    $.ajax({
      url: `${HOST}/api/v1/medicines/videos?q=${query}`, 
      headers: { "Authorization": `Token ${TOKEN}` },
      success: function(res){
        console.log(res)
        var html = '';

        var videos = res.payload.videos;
        for (let index = 0; index < videos.length; index++) {
          let med = videos[index];
          if (index == 0){
            var selected = 'selected';
          }else{
            var selected = '';
          }
          var matched_name = med
          html += `<li class="med ${selected} p-2" data-action="click->prescription#selectOption"> 
            ${matched_name}
          </li>`;
        }
        list.show()
        list.html( html )
      }
    })
  }

  // Helper function to normalize medicine names for better matching
  normalizeMedicineName(name) {
    if (!name) return '';
    
    // Convert to lowercase
    let normalized = name.toLowerCase();
    
    // Remove common words
    const wordsToRemove = ['tablet', 'tab', 'capsule', 'cap', 'mg', 'g', 'ml', 'injection', 'inj', 'syrup', 'syp'];
    wordsToRemove.forEach(word => {
      normalized = normalized.replace(new RegExp(`\\b${word}\\b`, 'g'), '');
    });
    
    // Remove extra spaces and trim
    normalized = normalized.replace(/\s+/g, ' ').trim();
    
    // Remove special characters except numbers
    normalized = normalized.replace(/[^a-z0-9\s]/g, '');
    
    return normalized;
  }

  // Helper function to calculate similarity score between two strings
  calculateSimilarity(str1, str2) {
    const normalized1 = this.normalizeMedicineName(str1);
    const normalized2 = this.normalizeMedicineName(str2);
    
    // If normalized strings are identical, return high score
    if (normalized1 === normalized2) return 1;
    
    // If one string contains the other, return medium-high score
    if (normalized1.includes(normalized2) || normalized2.includes(normalized1)) {
      return 0.8;
    }
    
    // Calculate word overlap
    const words1 = normalized1.split(' ');
    const words2 = normalized2.split(' ');
    const commonWords = words1.filter(word => words2.includes(word));
    
    // If there are common words, return medium score
    if (commonWords.length > 0) {
      return 0.6;
    }
    
    // If no match found, return low score
    return 0;
  }

  medicinesList(event){
    var list = $(event.target).parent().next(".medicinesList")
    if (event.target.value == ''){
      list.hide()
      list.html(null);
      return;
    }
    
    var html = '';
    const searchQuery = event.target.value ? event.target.value.toLowerCase() : '';
    const allMedicines = JSON.parse($(".all-medicines").text());
    var allMedicineSalts;
    if ($(".all-medicinesalt").length > 0){
      allMedicineSalts = JSON.parse($(".all-medicinesalt").text());
    }else{
      allMedicineSalts = []
    }


    // Filter MedicineSalts
    const filteredSalts = searchQuery 
      ? allMedicineSalts.filter(salt => salt.name?.toLowerCase()?.startsWith(searchQuery))
      : allMedicineSalts;

    // Filter Medicines
    let filteredMedicines = allMedicines;
    if (searchQuery) {
      filteredMedicines = filteredMedicines.filter(medicine =>
        medicine.name?.toLowerCase()?.startsWith(searchQuery)
      );
    }

    // Combine, limit, and sort the results
    const medicines = [...filteredMedicines, ...filteredSalts]
      .slice(0, 10)
      .sort((a, b) => a.name.length - b.name.length);

    for (let index = 0; index < medicines.length; index++) {
      let med = medicines[index];
      let type = "medicine"
      if (!med.company){
        type = "medicine_salt"
      }

      if (index == 0){
        var selected = 'selected';
      }else{
        var selected = '';
      }
      
      var matched_name = med.name.toLowerCase().includes(event.target.value.toLowerCase()) ? med.name : med.details
      html += `<li class="med ${selected} p-2" data-medicineid="${med.id}" 
      data-classtype="${type}"
      data-action="click->prescription#dump"> 
        ${matched_name?.trim()}
      </li>`;
    }
    list.show()
    list.html( html )
  }

  descriptionsList(event){
    var list = $(event.target).parent().next(".descriptionsList")
    if (event.target.value == 0){
      list.hide()
      list.html(null);
      return;
    }

    let html = '';
    const alldescriptions = JSON.parse($(".all-descriptions").text());
    const descriptions = alldescriptions.filter(function(remark){
      return remark.search_code.toLowerCase().startsWith(event.target.value.toLowerCase()) || remark.value.toLowerCase().startsWith(event.target.value?.toLowerCase())
    }).sort((a, b) => a.value.length - b.value.length)

    for (let index = 0; index < descriptions.length; index++) {
      let med = descriptions[index];
      if (index == 0){
        var selected = 'selected';
      }else{
        var selected = '';
      }
      html += `<li class="med ${selected} p-2" data-action="click->prescription#dump"> ${med.value} </li>`;
    }

    list.show()
    list.html( html )
  }

  remarksList(event){
    var list = $(event.target).parent().next(".remarksList")
    if (event.target.value == 0){
      list.hide()
      list.html(null);
      return;
    }

    let html = '';
    const allRemarks = JSON.parse($(".all-remarks").text());
  
    const remarks = allRemarks.filter(function(remark){
      return remark.value.toLowerCase().startsWith(event.target.value.toLowerCase())
    }).sort((a, b) => a.value.length - b.value.length)

    if (remarks.length == 0){
      list.hide()
      list.html(null);
      return;
    }
    for (let index = 0; index < remarks.length; index++) {
      let med = remarks[index];
      if (index == 0){
        var selected = 'selected';
      }else{
        var selected = '';
      }
      html += `<li class="med ${selected} p-2" data-action="click->prescription#dump"> ${med.value} </li>`;
    }
    list.show()
    list.html( html )
  }
  
  fillAppointment(event){
    var block = this;
    var prescriptionId = $(event.target).attr("data-prescriptionid")
    showLoader($('.prep-data'));
    $(".investigations").html(null)

    // If perscription is not generated yet, pull previous prescription
    if (!prescriptionId){
      var pastPrescriptionId = $(event.target).parent().prev().find(".appointment-tabs").attr("data-prescriptionId")
    }

    var appointmentId = $(event.target).attr("data-appointmentid")
    var patientId = $("#save_update, #saveprint").attr("data-patientId")
    $(".appts span").removeClass("bg-theme")
    $(event.target).addClass("bg-theme")

    if (appointmentId){

      // Check for AI summary before loading appointment data
      block.checkAISummary(patientId, appointmentId, () => {});

      $.ajax({
        url: `${HOST}/api/v1/appointments/${appointmentId}`,
        headers: { "Authorization": `Token ${TOKEN}` },
        success:  function(res){
          console.log(res)
          var medParams = res.payload.ready_investigations
          newInvestigations(medParams, appointmentId)

          if (res.payload.ir_samples.length > 0){
            $("#show-ir-samples").attr('href', `/prescription/show_samples?appointment_id=${appointmentId}`).show()
          }else{
            $("#show-ir-samples").attr('ahref', null).hide()
          }
          if (res.payload.visit_date == (new Date().toISOString().split('T')[0])){
            $("#save_update, #saveprint, #create_visit").show()
            $("#prescription_reprint").addClass("d-none")
          }else{
            $("#save_update, #saveprint, #create_visit").hide()
            $("#prescription_reprint").removeClass("d-none")
          }
        }
      })

      $("#saveprint, #save_update, #prescription_reprint").attr("data-prescriptionid", prescriptionId)
      fillPrescriptionData(prescriptionId || pastPrescriptionId)
    }else{
      var  patientId = $("#save_update, #saveprint").attr("data-patientId")
      $.ajax({
        url: `${HOST}/api/v1/appointments/ready_investigations?patient_id=${ patientId}`,
        headers: { "Authorization": `Token ${TOKEN}` },
        success:  function(res){
          console.log(res)
          newInvestigations(res.payload.tests, '')
          $("#show-ir-samples").hide()
          $("#save_update, #saveprint, #create_visit").show()
          $("#prescription_reprint").attr("data-prescriptionid", null).addClass("d-none")
        }
      })
    }
    hideLoader($('.prep-data'));
  }

  removeInvestigation(event){
    var $el = $(event.target)
    var appointmentId = $el.attr("data-appointmentid");
    var test = $el.parent().attr("data-test");
    if (appointmentId){
      $.ajax({
        url: `/api/v1/appointments/${appointmentId}/remove_investigations?test=${test}`,
        method: "PUT",
        headers: { "Authorization": `Token ${TOKEN}` },
        success: function(res){
          console.log(res)
          $el.parent().remove()
          $(`#medical_param`).append(`<option value='${test}'>${test}</option>`)
          $('#medical_param').selectpicker('refresh');
        },
        error: function(errr){
          console.log(errr)
        }
      })
    }else{
      $el.parent().remove()
      $(`#medical_param`).append(`<option value='${test}'>${test}</option>`)
      $('#medical_param').selectpicker('refresh');
    }
  }

  treatmentData(event){
    var treatmentId = event.target.value
    if (treatmentId){
      fillTreatmentData(treatmentId)
    }else{
      clearTreatmentAndPrescription()
    }
  }

  loadReferrers(event){
    var text = $(event.target).val();
    var list = $(event.target).parent().next(".referrersList")
    if (event.target.value == ''){
      list.hide()
      list.html(null);
      return;
    }

    $.ajax({ 
      url:`${HOST}/api/v1/referrers?q=${event.target.value}`, 
      headers: { "Authorization": `Token ${TOKEN}` },
      success: function(res){
        console.log(res)
        var html = '';
        var referrers = res.payload.referrers;
        for (let index = 0; index < referrers.length; index++) {
          let med = referrers[index];
          if (index == 0){
            var selected = 'selected';
          }else{
            var selected = '';
          }
          html += `<li class="med ${selected} p-2" data-action="click->prescription#dump"> 
            ${med.full_name || ''} ${med.qualification || ''} ${med.profession || ''} ${med.address || ''} ${med.phone || ''} ${med.email || ''}
            
            <a data-remote="true" data-referrer_id="${med.id}" data-action="click->prescription#referrerForm" class="text-dark pl-2"><i class="fa fa-pencil">  </i></a>
          </li>`;
        }
        list.show()
        list.html(`<a class="btn btn-warning btn-sm d-block" data-remote="true" data-remote="true" data-action="click->prescription#referrerForm"> Add Referrer </a> ${html}`)
      }
    })
  }

  editSpellingForm(event){
    var type = $(event.target).attr("data-type")
    var entityId = $(event.target).parent().find('select').val();
    var text = $(event.target).parent().find(`select option[value="${entityId}"]`).text()
    $(".modal").modal('hide');
    $(".modal-container").html(`
      <!-- Modal -->
      <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" data-controller="prescription" aria-hidden="true">
        <div class="modal-dialog modal-sm" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="h5" id="exampleModalLabel">  Update / Create ${type}</h5>
            </div>

            <div class="modal-body">
              <input type="text" id="new-spelling" value="${text}" class="mb-2 form-control" placeholder="Edit option">
              <span class="btn btn-sm" data-type="${type}" data-action="click->prescription#saveSpelling" data-id="${entityId}">Save</span>
            </div>
          </div>
        </div>
      </div>
    `);
    $(".modal").modal('show');
  }

  saveSpelling(event){
    var type = $(event.target).attr("data-type")
    var $el  = $(`#patient_${type}_id`)
    var entityId = $(event.target).attr("data-id")
    var value = $("#new-spelling").val()
    $.ajax({
      url: `${HOST}/api/v1/master/save_spelling/`,
      headers: { "Authorization": `Token ${TOKEN}` },
      method: "put",
      data: {
        value: value,
        id: entityId,
        type: type
      },
      success: function(res){
        console.log(res)
        $(".modal").modal('hide');
        $el.find(`option[value='${res.payload.id}']`).remove()
        $el.append($('<option>', {
          value: res.payload.id,
          text: res.payload.title
        })).selectpicker('refresh');
        $el.val(res.payload.id).trigger("change")
      },
      error: function(err){
        console.log(err)
        $("#new-spelling").css({"border": "1px solid red"})
        $("#new-spelling").after(`<span class="d-block err text-danger"> ${err.responseJSON.status.message}</span>`)
      }
    })
  }

  referrerForm(event){
    event.preventDefault()
    event.stopPropagation()
    var referrerId = $(event.target).closest("a").attr("data-referrer_id");

    if (!referrerId){
      referrerId = $("#appointment_referrer_id").val() 
    }
    $.get(`/prescription/referrer_form?referrer_id=${referrerId}`)
    return false;
  }

  saveReferrer(event){
    event.preventDefault()
    var $form = $(event.target)
    var referrer_id = $form.attr("data-referrer-id")
    if (referrer_id){
      var type = "PUT" 
    }else{
      var type = "POST"
    }
    $.ajax({
      url: `${HOST}/api/v1/referrers/${referrer_id || ''}`,
      headers: { "Authorization": `Token ${TOKEN}` },
      method: type,
      data: {
        data: $form.serializeArray(),
      },
      success: function(res){
        console.log(res)
        if (res.payload){
          flashToast("Referrer Saved","info")
          $(".modal").modal('hide');
          $("#appointment_referrer_id").append(`
            <option value="${res.payload.id}">
              ${res.payload.full_name} - ${res.payload.address}
            </option>
          `)
            .val(res.payload.id)
            .trigger('change')
            .selectpicker('refresh');
        }
      },
      error: function(err){
        console.log(err)
        flashToast(err.responseJSON.status.message, "warning")
      }
    })
  }

  cancel(event){
    var appointmentId = $(event.target).closest("a").attr('data-appointmentId');
    var tr = $(event.target).parents("tr");
    $.ajax({
      url: `${HOST}/api/v1/appointments/${appointmentId}/cancel`,
      headers: { "Authorization": `Token ${TOKEN}` },
      method: "put",
      success: function(res){
        console.log(res)
        tr.remove();
      }
    })
  }

  loadAllAppointments(event){
    const patientId = $(event.target).attr('data-patientid');
    $.ajax({
      url:  `${HOST}/api/v1/patients/${patientId}?appointments=true`, 
      headers: { "Authorization": `Token ${TOKEN}` },
      success: function(res){
        createAppointmentTabs(res, "all")
      }
    })
  }

  referralTemplate(event){
    event.stopPropagation()
    var referrerId = $("#appointment_referrer_id").val() 
    var patientId = $("#saveprint").attr("data-patientid")
    if (!patientId){
      flashToast("No Patient Selected", "warning")
      return;
    }
    $.get(`/prescription/referrer_template?referrer_id=${referrerId}&patient_id=${patientId}`, function(){
      $(".send-email").attr("data-referrerid", referrerId) 
    })
  }

  sendReferralMail(event){
    var referrerId = $(".send-email").attr("data-referrerid") 
    var patientId = $("#saveprint").attr("data-patientid")
    var content = referrerTemplate.getData()

    $.ajax({
      url: `/prescription/send_referrer_mail`, 
      headers: { "Authorization": `Token ${TOKEN}` },
      method: "POST",
      data: {
        content: content,
        referrer_id: referrerId,
        patient_id: patientId
      },
      success: function(res){
        flashToast("Mail sent Successfully", "info")
      }
    })
  }

  save(event){
    event.preventDefault();
    this.savePrescription(event.target, false)
  }

  savePrescription(el, print){
    var $form = $(el).parents('form')
    var appointment_id = $(el).attr("data-appointmentid");
    var prescription_id = $(el).attr("data-prescriptionid");
    var opts = { 
      data: $form.serializeArray(),
      appointment_id: appointment_id,
      prescription_id: prescription_id
    }
    var patientId = $("#saveprint").attr("data-patientid")
    const cabinEntryTimeRaw = JSON.parse(localStorage.getItem("cabinEntries")) || {};

    if (print){
      console.log('cabinEntryTimeRaw', cabinEntryTimeRaw, 'patientId', patientId)
      opts['prescription_print'] = true
      opts['cabin_entry_time'] = cabinEntryTimeRaw?.entryTime || null
    }
    $.ajax({
      url: `/api/v1/prescriptions/`, 
      headers: { "Authorization": `Token ${TOKEN}` },
      method: "POST",
      data: opts, 
      success: function(res){
        console.log(res)
        if (res.status.status == "SUCCESS"){
          $("#save_update, #saveprint").attr("data-prescriptionid", res.payload.id);
          $(`.appointment-tabs[data-appointmentid='${appointment_id}']`).attr("data-prescriptionid", res.payload.id);
          flashToast("Prescription Updated Successfully", "info")
          if (res.payload.id && print){
            flashToast("Generating Prescription", "info")
            printPage(res.payload.content);
            $(`#patient-visit-${res.payload.patient_id}`).parents("tr").remove()

            removeCabinEntry(res.payload.patient_id)
          }

        }else{
          flashToast(err.responseJSON.status.message, "warning")
        } 
      },
      error: function(err){
        try {
          var msg = err.responseJSON.status.message
        }catch {
          var msg = "Something Happened. Please check the values again"
        }
        flashToast(msg, "warning")
      }
    })
  }

  printPrescription(event){
    event.preventDefault()
    this.savePrescription(event.target, true)
    $.ajax({
      url:  `${HOST}/prescription/reload_visits`, 
      headers: { "Authorization": `Token ${TOKEN}` },
      success: function(){}
    })

    // Upload Audio if present
    try {
      const audioBlob = $("#upload-audio").data("audioBlob");
      const formData = new FormData();
      var appointmentId = $("#save_update").attr("data-appointmentid");
      if (!audioBlob) { return false; }

      formData.append("voice[audio_file]", audioBlob, "recording.webm");
      formData.append("audio_appointment_id", appointmentId);

      // Stop audio playback
      const audioElement = $("#audio-preview")[0]; // Get the audio element
      if (audioElement) {
        audioElement.pause(); // Stop the playback
        audioElement.currentTime = 0; // Reset to the start
      }

      $.ajax({
        url: "/prescription/voice_uploads",
        method: "POST",
        data: formData,
        processData: false,
        contentType: false,
        success: function (response) {
          flashToast("Uploaded", "info")
          $("#upload-audio, .recording-btn, #audio-preview, #show-ir-samples").hide();
          return false;
        },
        error: function (e) {
          console.log(e.responseJSON.errors)
          flashToast(e.responseJSON.errors, "warning")
          $("#upload-audio, .recording-btn, #audio-preview, #show-ir-samples").hide();
          return false;
        },
      });
    } catch(err) {
      console.table(err);
    }
    return false;
  } 

  reprint(event){
    event.preventDefault();
    var prescription_id =  $(event.target).attr('data-prescriptionid');
    $.ajax({
      url:  `${HOST}/api/v1/prescriptions/${prescription_id}`, 
      headers: { "Authorization": `Token ${TOKEN}` },
      success: function(res){
        console.log(res)
        if (res.status.status == "SUCCESS"){
          flashToast("Generating Prescription", "info")
          printPage(res.payload.content);
        }else{
          flashToast(err.responseJSON.status.message, "warning")
        } 
      },
      error: function(err){
        try {
          var msg = err.responseJSON.status.message
        }catch {
          var msg = "Something Happened. Please check the values again"
        }
        flashToast(msg, "warning")
      }
    })
  }

  printReferral(event){
    var referrerId = $(event.target).attr("data-referrer-id");
    var patientId = $("#saveprint").attr("data-patientid");
    var appointmentId = $("#saveprint").attr("data-appointmentId");
    var content = referrerTemplate.getData();

    content = `<div class=""> <hr> ${content} </div>`;

    $.ajax({
      url: `/prescription/print_referral`,
      method: "POST",
      headers: { "Authorization": `Token ${TOKEN}` },
      data:{
        content: content,
        referrer_id: referrerId,
        appointment_id: appointmentId,
        patient_id: patientId
      },
      success: function(res){
        console.log(res)
        printPage(res.payload.content); 
      },
      error: function(err){
        flashToast("Something Happened. Try again", "warning")
      }
    })
  }

  getCounts(event){
    var doctorId = $(event.currentTarget).attr("data-doctorid")
    $.ajax({
      url:  `${HOST}/prescription/get_counts?doctor_id=${doctorId}`, 
      headers: { "Authorization": `Token ${TOKEN}` },
      success: function(){}
    })
  }

  newVisit(event){
    takeAppointment()
    var context = this;
    $("#save_update, #saveprint").attr("data-prescriptionid", null)
    setTimeout(function(){ context.savePrescription($("#save_update")[0], false) }, 2000);
  }

  showMedicineReminders(event) {
    event.preventDefault();
    // Ensure voice note modal is removed if it exists
    $('#voiceNoteModal').remove();
    
    var patientId = $("#saveprint").attr("data-patientid");
    var prescriptionId = $("#saveprint").attr("data-prescriptionid");
    if (!patientId) {
      flashToast("No Patient Selected", "warning");
      return;
    }
    $.get(`/prescription/medicine_reminders?patient_id=${patientId}&prescription_id=${prescriptionId}`);
  }

  showAllQueries(event) {
    event.preventDefault();
    // Remove any existing modal
    $('#allQueriesModal').remove();
    
    // Load and show the modal
    $.get('/prescription/all_queries')
      .done((html) => {
        $('body').append(html);
        $('#allQueriesModal').modal('show');
        
        // Initialize search debounce
        this.initializeAllQueriesSearch();
      })
      .fail(() => {
        flashToast("Error loading enquiries", "error");
      });
  }

  initializeAllQueriesSearch() {
    // Create debounced search function if not already created
    if (!this.allQueriesSearchDebounced) {
      this.allQueriesSearchDebounced = debounce((searchTerm) => {
        const activeTab = document.querySelector('#allQueriesStatusTabs .nav-link.active');
        const status = activeTab ? activeTab.getAttribute('data-status') : 'all';
        this.loadAllQueriesList(status, searchTerm);
      }, 300);
    }
  }

  searchAllQueries(event) {
    const searchTerm = event.target.value;
    
    // Initialize debounce if needed
    this.initializeAllQueriesSearch();
    
    // Use debounced function
    if (this.allQueriesSearchDebounced) {
      this.allQueriesSearchDebounced(searchTerm);
    } else {
      // Fallback if debounce not initialized
      const activeTab = document.querySelector('#allQueriesStatusTabs .nav-link.active');
      const status = activeTab ? activeTab.getAttribute('data-status') : 'all';
      this.loadAllQueriesList(status, searchTerm);
    }
  }

  filterAllQueries(event) {
    event.preventDefault();
    const status = event.currentTarget.getAttribute('data-status');
    
    // Update active tab
    document.querySelectorAll('#allQueriesStatusTabs .nav-link').forEach(tab => {
      tab.classList.remove('active');
    });
    event.currentTarget.classList.add('active');
    
    // Get search term
    const searchInput = document.getElementById('all-queries-search');
    const searchTerm = searchInput ? searchInput.value : '';
    
    // Load queries with new filter
    this.loadAllQueriesList(status, searchTerm);
  }

  loadAllQueriesList(status, searchTerm = '') {
    let url = '/prescription/all_queries?';
    if (status && status !== 'all') {
      url += `status=${status}`;
    }
    
    if (searchTerm) {
      url += status && status !== 'all' ? `&search=${encodeURIComponent(searchTerm)}` : `search=${encodeURIComponent(searchTerm)}`;
    }
    
    $.get(url)
      .done((html) => {
        // Extract just the list part from the modal HTML
        const tempDiv = $('<div>').html(html);
        const listHtml = tempDiv.find('#all-queries-list-container').html();
        if (listHtml) {
          $('#all-queries-list-container').html(listHtml);
        }
      })
      .fail(() => {
        flashToast("Error loading enquiries", "error");
      });
  }

  loadQueryChatThread(event) {
    const queryId = event.currentTarget.getAttribute('data-query-id');
    if (!queryId) return;
    
    // Update active query item
    document.querySelectorAll('.query-item-all').forEach(item => {
      item.classList.remove('active');
    });
    event.currentTarget.classList.add('active');
    
    // Load chat thread
    const chatThreadContainer = document.getElementById('all-queries-chat-thread');
    if (!chatThreadContainer) return;
    
    chatThreadContainer.innerHTML = '<div class="text-center p-4">Loading conversation...</div>';
    
    fetch(`/prescription/query_chat_thread?id=${queryId}`)
      .then(response => response.text())
      .then(html => {
        chatThreadContainer.innerHTML = html;
        this.scrollChatToBottom(chatThreadContainer);
        
        // Attach form submit handler
        const form = chatThreadContainer.querySelector('.chat-thread-form');
        if (form) {
          form.onsubmit = (e) => {
            e.preventDefault();
            this.sendQueryReplyAllQueries(form, queryId, chatThreadContainer);
          };
        }
        
        // Attach resolve button handler
        const resolveButton = chatThreadContainer.querySelector('[data-action*="resolveQuery"]');
        if (resolveButton) {
          resolveButton.onclick = (e) => {
            e.preventDefault();
            this.resolveQueryAllQueries(e, queryId, chatThreadContainer);
          };
        }
      })
      .catch(() => {
        chatThreadContainer.innerHTML = '<div class="text-center p-4 text-danger">Error loading conversation.</div>';
      });
  }

  sendQueryReplyAllQueries(form, queryId, chatThreadContainer) {
    const input = form.querySelector('input[name="message"]');
    const message = input.value.trim();
    if (!message) return;
    
    input.disabled = true;
    form.querySelector('button[type="submit"]').disabled = true;
    
    fetch('/prescription/create_query_reply', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: JSON.stringify({ query_id: queryId, message })
    })
      .then(response => response.text())
      .then(html => {
        chatThreadContainer.innerHTML = html;
        this.scrollChatToBottom(chatThreadContainer);
        
        // Re-attach form handler
        const newForm = chatThreadContainer.querySelector('.chat-thread-form');
        if (newForm) {
          newForm.onsubmit = (e) => {
            e.preventDefault();
            this.sendQueryReplyAllQueries(newForm, queryId, chatThreadContainer);
          };
        }
        
        // Re-attach resolve button handler
        const resolveButton = chatThreadContainer.querySelector('[data-action*="resolveQuery"]');
        if (resolveButton) {
          resolveButton.onclick = (e) => {
            e.preventDefault();
            this.resolveQueryAllQueries(e, queryId, chatThreadContainer);
          };
        }
      })
      .finally(() => {
        input.value = '';
        input.disabled = false;
        if (form.querySelector('button[type="submit"]')) {
          form.querySelector('button[type="submit"]').disabled = false;
        }
      });
  }

  resolveQueryAllQueries(event, queryId, chatThreadContainer) {
    event.preventDefault();
    if (!queryId || !chatThreadContainer) return;
    
    event.currentTarget.disabled = true;
    
    fetch('/prescription/resolve_query', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: JSON.stringify({ query_id: queryId })
    })
      .then(response => response.text())
      .then(html => {
        chatThreadContainer.innerHTML = html;
        
        // Re-attach form handler
        const form = chatThreadContainer.querySelector('.chat-thread-form');
        if (form) {
          form.onsubmit = (e) => {
            e.preventDefault();
            this.sendQueryReplyAllQueries(form, queryId, chatThreadContainer);
          };
        }
        
        // Update the query status in the list
        const queryItem = document.querySelector(`.query-item-all[data-query-id="${queryId}"]`);
        if (queryItem) {
          const statusBadge = queryItem.querySelector('.query-status-badge-all');
          if (statusBadge) {
            statusBadge.textContent = 'Resolved';
            statusBadge.className = 'query-status-badge-all resolved';
          }
        }
      })
      .finally(() => {
        if (event.currentTarget) {
          event.currentTarget.disabled = false;
        }
      });
  }

  async toggleRecording(event) {
    const button = event.currentTarget;
    
    // Safely get elements with null checks
    const buttonText = button.querySelector('.button-text');
    const spinner = button.querySelector('.spinner-border');

    // Update button text safely
    const updateButtonText = (text) => {
      if (buttonText) {
        buttonText.textContent = text;
      }
    };

    // Update button state
    const updateButtonState = (isRecording) => {
      if (isRecording) {
        button.classList.add('recording');
        updateButtonText('Stop & Process');
      } else {
        button.classList.remove('recording');
        updateButtonText('Start Recording');
      }
    };

    if (!this.mediaRecorder) {
      try {
        // First check if permission was already granted
        const permissionStatus = await navigator.permissions.query({ name: 'microphone' });
        
        if (permissionStatus.state === 'denied') {
          alert('Microphone access is blocked. Please enable it in your browser settings and refresh the page.');
          return;
        }

        // Request microphone access
        const stream = await navigator.mediaDevices.getUserMedia({ 
          audio: {
            echoCancellation: true,
            noiseSuppression: true,
            sampleRate: 44100
          }
        });

        this.mediaRecorder = new MediaRecorder(stream);
        
        this.mediaRecorder.ondataavailable = (e) => {
          this.audioChunks.push(e.data);
        };

        this.mediaRecorder.onstop = async () => {
          const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
          await this.processAudio(audioBlob, button, spinner);
          this.audioChunks = [];
          
          // Stop all tracks
          stream.getTracks().forEach(track => track.stop());
          this.mediaRecorder = null;
          
          // Reset button state
          updateButtonState(false);
        };

        // Start recording
        this.mediaRecorder.start();
        updateButtonState(true);
        
      } catch (err) {
        console.error('Error accessing microphone:', err);
        if (err.name === 'NotAllowedError') {
          alert('Microphone access was denied. Please enable it and refresh the page.');
        } else if (err.name === 'NotFoundError') {
          alert('No microphone found. Please connect a microphone and try again.');
        } else {
          alert('Error accessing microphone: ' + err.message);
        }
        // Reset button state on error
        updateButtonState(false);
      }
    } else {
      // Stop recording
      this.mediaRecorder.stop();
      updateButtonState(false);
    }
  }

  async processAudio(audioBlob, button, spinner) {
    try {
      // Show spinner
      spinner.classList.remove('d-none');
      button.disabled = true;

      // Create FormData and append the audio blob
      const formData = new FormData();
      formData.append('audio_file', audioBlob, 'recording.wav');

      // First, upload the file to get its URL
      const uploadResponse = await fetch('/prescription/upload_audio', {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector("[name='csrf-token']").content
        },
        body: formData
      });

      const uploadData = await uploadResponse.json();

      if (!uploadData.success) {
        throw new Error('Failed to upload audio file');
      }

      // Now send the file URL to the transcription endpoint
      const transcribeResponse = await fetch('/prescription/generate_voice_note', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector("[name='csrf-token']").content
        },
        body: JSON.stringify({
          audio_file: uploadData.audio_url
        })
      });

      const data = await transcribeResponse.json();

      if (data.success) {
        // Remove any existing voice note modal
        var prescription = JSON.parse(data.json);
        console.log(prescription);

        if (prescription.diagnosis?.length > 0) {
          let prescription_diagnosis = $("#prescription_diagnosis_").val();
          $("#prescription_diagnosis_").val(`${prescription_diagnosis} ${prescription.diagnosis.join(", ")}`);
        }
        
        if (prescription.notes) {
          let prescription_notes = $("#prescription_notes_").val();
          $("#prescription_notes_").val(`${prescription_notes} ${prescription.notes}`);
        }

        if (prescription.self_notes) {
          let prescription_self_notes = $("#prescription_self_notes_").val();
          $("#prescription_self_notes_").val(`${prescription_self_notes} ${prescription.self_notes}`);
        }
        
        if (prescription.special_instructions?.length > 0) {
          let prescription_special_instructions = $("#prescription_special_instructions_").val();
          $("#prescription_special_instructions_").val(`${prescription_special_instructions} ${prescription.special_instructions.join(", ")}`);
        }

        // Handle medicines from transcription
        if (prescription.medicines?.list?.length > 0) {
          // Get existing medicines from the table
          const existingMedicines = [];
          $(".treatment-table tbody tr").each(function() {
            const medicineName = $(this).find('input[name="treatment_medicine[name]"]').val();
            const medicineId = $(this).find('input[name="treatment_medicine[medicine_id]"]').val();
            if (medicineName) {
              existingMedicines.push({
                name: medicineName.toLowerCase(),
                id: medicineId,
                element: $(this)
              });
            }
          });

          const allMedicines = JSON.parse($(".all-medicines").text());
          var allMedicineSalts;
          if ($(".all-medicinesalt").length > 0){
            allMedicineSalts = JSON.parse($(".all-medicinesalt").text());
          }else{
            allMedicineSalts = []
          }
          const allSearchableItems = [...allMedicines, ...allMedicineSalts];

          // Add each medicine to the table
          for (const transcribedMedicine of prescription.medicines.list) {
            // First check if this medicine already exists in the table
            const existingMatch = existingMedicines.find(existing => 
              this.calculateSimilarity(transcribedMedicine.name, existing.name) >= 0.8
            );

            if (existingMatch) {
              // Update the existing row with new information if needed
              const row = existingMatch.element;
              const descriptionInput = row.find('input[name="treatment_medicine[description]"]');
              const remarkInput = row.find('input[name="treatment_medicine[remark]"]');
              
              if (transcribedMedicine.description && !descriptionInput.val()) {
                descriptionInput.val(transcribedMedicine.description);
                descriptionInput.attr('data-original-prediction', transcribedMedicine.description);
              }
              if (transcribedMedicine.remark && !remarkInput.val()) {
                remarkInput.val(transcribedMedicine.remark);
                remarkInput.attr('data-original-prediction', transcribedMedicine.remark);
              }
              
              // Setup change detection for updated row
              this.setupFieldChangeDetection(row[0]);
              continue;
            }

            // If no existing match, find best match from all medicines
            let bestMatch = null;
            let highestSimilarity = 0;
            const searchName = transcribedMedicine.name;

            for (const item of allSearchableItems) {
              const similarity = this.calculateSimilarity(searchName, item.name);
              if (similarity > highestSimilarity && similarity >= 0.6) {
                highestSimilarity = similarity;
                bestMatch = item;
              }
            }

            let medicineId = null;
            let medicineName = searchName; // Default to transcribed name if no good match
            let classtype = null;

            if (bestMatch) {
              medicineId = bestMatch.id;
              medicineName = bestMatch.name;
              classtype = bestMatch.company ? "medicine" : "medicine_salt";
            }

            // Create new row
            const newRow = `
              <tr data-carryforwarded="false">
                <td class="p-1">
                  <div class="form-group">
                    <input type="text" name="treatment_medicine[name]" id="treatment_medicine_name" class="form-control ${medicineId ? "" : 'border-red'} medicine" autocomplete="off" placeholder="Medicine" data-medicineid="${medicineId}" value="${medicineName}" data-action="input->prescription#medicinesList">
                    <input type="hidden" name="treatment_medicine[medicine_id]" value="${medicineId}" />
                    <input type="hidden" name="treatment_medicine[class_type]" value="${classtype}" />
                  </div>
                  <div class="medicinesList custom-select-list">
                  </div>
                </td>
                <td class="p-1">
                  <div class="form-group">
                    <input type="text" name="treatment_medicine[description]" id="treatment_medicine_description" class="form-control description" autocomplete="off" placeholder="Description" value="${transcribedMedicine.description || ''}" data-original-prediction="${transcribedMedicine.description || ''}" data-action="input->prescription#descriptionsList">
                  </div>
                  <div class="descriptionsList custom-select-list">
                  </div>
                  <div class="feedback-section">
                    <a href="#" class="feedback-link" data-field-type="description" data-action="click->prescription#showFeedbackField keydown->prescription#handleFeedbackKeydown" tabindex="-1" style="font-size: 12px; color: #007bff; text-decoration: none; display: none;">wrong?</a>
                    <div class="feedback-textarea" style="display: none; margin-top: 5px;">
                      <textarea class="form-control" rows="3" placeholder="What should it be?" data-action="blur->prescription#saveFeedback" data-field-type="description"></textarea>
                    </div>
                  </div>
                </td>
                <td class="p-1">
                  <div class="form-group">
                    <input type="text" name="treatment_medicine[remark]" id="treatment_medicine_remark" class="form-control remark" autocomplete="off" placeholder="Remarks" value="${transcribedMedicine.remark || ''}" data-original-prediction="${transcribedMedicine.remark || ''}" data-action="input->prescription#remarksList">
                  </div>
                  <div class="remarksList custom-select-list">
                  </div>
                  <div class="feedback-section">
                    <a href="#" class="feedback-link" data-field-type="remark" data-action="click->prescription#showFeedbackField keydown->prescription#handleFeedbackKeydown" tabindex="-1" style="font-size: 12px; color: #007bff; text-decoration: none; display: none;">wrong?</a>
                    <div class="feedback-textarea" style="display: none; margin-top: 5px;">
                      <textarea class="form-control" rows="3" placeholder="What should it be?" data-action="blur->prescription#saveFeedback" data-field-type="remark"></textarea>
                    </div>
                  </div>
                </td>
                <td class="p-1">
                  <span class="medicine-efficiency d-block text-center">-</span>
                </td>
                <td class="p-1">
                  <div class="text-center">
                    <a class="btn btn-theme btn-sm" data-action="click->prescription#removeMedicine" data-remote="true" href="/prescription">Remove</a>
                  </div>
                </td>
              </tr>
            `;

            // Append row to table
            $(".treatment-table tbody").append(newRow);
            
            // Setup change detection for the new row
            const newRowElement = $(".treatment-table tbody tr").last()[0];
            this.setupFieldChangeDetection(newRowElement);
          }
        }
      }
    } finally {
      // Hide spinner and enable button
      spinner.classList.add('d-none');
      button.disabled = false;
    }
  }

  // New function specifically for medicine selection
  selectMedicine(event) {
    // First call the original dump function
    this.dump(event);
    
    // Then handle the tab navigation
    const currentRow = $(event.target).closest('tr');
    const nextInput = currentRow.find('input[name="treatment_medicine[description]"]');
    if (nextInput.length) {
      nextInput.focus();
    }
  }

  toggleQueryChatThread(event) {
    const queryId = event.currentTarget.getAttribute('data-query-id');
    const threadContainer = document.getElementById(`query-chat-thread-${queryId}`);
    // Close any open thread
    document.querySelectorAll('.query-chat-thread-container').forEach(el => {
      if (el !== threadContainer) el.style.display = 'none';
    });
    // Toggle this thread
    if (threadContainer.style.display === 'block') {
      threadContainer.style.display = 'none';
      return;
    }
    threadContainer.style.display = 'block';
    threadContainer.innerHTML = '<div class="text-center p-4">Loading conversation...</div>';
    fetch(`/prescription/query_chat_thread?id=${queryId}`)
      .then(response => response.text())
      .then(html => {
        threadContainer.innerHTML = html;
        this.scrollChatToBottom(threadContainer);
        // Attach form submit handler
        const form = threadContainer.querySelector('.chat-thread-form');
        if (form) {
          form.onsubmit = (e) => {
            e.preventDefault();
            this.sendQueryReply(form, queryId, threadContainer);
          };
        }
      });
  }

  sendQueryReply(form, queryId, threadContainer) {
    const input = form.querySelector('input[name="message"]');
    const fileInput = form.querySelector('input[name="attachments[]"]');
    const message = input.value.trim();

    // Optional: allow file without message
    if (!message && fileInput.files.length === 0) return;

    input.disabled = true;
    form.querySelector('button[type="submit"]').disabled = true;

    // Use FormData instead of JSON
    let formData = new FormData();
    formData.append("query_id", queryId);
    formData.append("query_reply[message]", message);

    // add attachments
    if (fileInput && fileInput.files.length > 0) {
      Array.from(fileInput.files).forEach((file) => {
        formData.append("query_reply[attachments][]", file);
      });
    }

    fetch('/prescription/create_query_reply', {
      method: 'POST',
      headers: {
        // DO NOT SET Content-Type!
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content
      },
      body: formData
    })
      .then(response => response.text())
      .then(html => {
        threadContainer.innerHTML = html;
        this.scrollChatToBottom(threadContainer);

        // Re-attach handler for new form
        const newForm = threadContainer.querySelector('.chat-thread-form');
        if (newForm) {
          newForm.onsubmit = (e) => {
            e.preventDefault();
            this.sendQueryReply(newForm, queryId, threadContainer);
          };
        }
      })
      .finally(() => {
        input.value = '';
        input.disabled = false;
        form.querySelector('button[type="submit"]').disabled = false;
        if (fileInput) fileInput.value = ""; // clear file input
      });
  }

  scrollChatToBottom(container) {
    const messages = container.querySelector('.chat-thread-messages');
    if (messages) messages.scrollTop = messages.scrollHeight;
  }

  resolveQuery(event) {
    event.preventDefault();
    const queryId = event.currentTarget.getAttribute('data-query-id');
    const threadContainer = document.getElementById(`query-chat-thread-${queryId}`);
    if (!queryId || !threadContainer) return;
    event.currentTarget.disabled = true;
    fetch('/prescription/resolve_query', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: JSON.stringify({ query_id: queryId })
    })
      .then(response => response.text())
      .then(html => {
        threadContainer.innerHTML = html;
      });
  }

  // Isolated method to predict remarks for a specific medicine row
  async predictRemarksForMedicineRow(rowElement) {
    try {
      // Check if this is a carryforwarded row
      const isCarryforwarded = $(rowElement).attr('data-carryforwarded') === 'true';
      if (isCarryforwarded) {
        console.log('Skipping prediction for carryforwarded row');
        return;
      }

      const $row = $(rowElement);
      const medicineName = $row.find('input[name="treatment_medicine[name]"]').val();
      const description = $row.find('input[name="treatment_medicine[description]"]').val();
      // Gather context from the form
      const context = {
        diagnosis: $("#prescription_diagnosis_").val()?.split(",").map(d => d.trim()) || [],
        other_medicines: []
      };
      // Get other medicines from the table (excluding current row)
      $(".treatment-table tbody tr").each(function() {
        if (this !== rowElement) {
          const medName = $(this).find('input[name="treatment_medicine[name]"]').val();
          if (medName) {
            context.other_medicines.push({
              name: medName,
              description: $(this).find('input[name="treatment_medicine[description]"]').val() || "",
              remark: $(this).find('input[name="treatment_medicine[remark]"]').val() || ""
            });
          }
        }
      });
      context.patient_age = $("#patient_age").val();
      context.patient_gender = $("#patient_gender").val();
      context.special_instructions = $("#prescription_special_instructions_").val()?.split(",").map(i => i.trim()) || [];
      context.medical_tests = $("#prescription_medical_tests_").val()?.split(",").map(t => t.trim()) || [];

      // Prepare payload — include description for remark-only prediction
      const patientId = $("#save_update, #saveprint").attr("data-patientId") || "";
      const payload = {
        medicine_name: medicineName,
        patient_id: patientId,
        description: description,
        context: context
      };

      // Make the API call
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
      const response = await fetch(`/prescription/predict_medicine`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      const prediction = data.predictions && data.predictions[0];
      if (prediction && prediction.predicted_remark) {
        const remarkField = $row.find('input[name="treatment_medicine[remark]"]')[0];
        // Only fill if the doctor hasn't already typed something in remark
        if (!remarkField.value || remarkField.value === remarkField.getAttribute('data-original-prediction') || remarkField.value === '') {
          remarkField.value = prediction.predicted_remark;
          remarkField.setAttribute('data-original-prediction', prediction.predicted_remark);
        }
        this.setupFieldChangeDetection(rowElement);
      } else {
        // No prediction — mark remark field for "save for future" prompt
        const remarkField = $row.find('input[name="treatment_medicine[remark]"]')[0];
        if (remarkField) {
          remarkField.setAttribute('data-no-prediction', 'true');
          this.setupFieldChangeDetection(rowElement);
        }
      }
    } catch (error) {
      console.error('Error predicting remarks:', error);
      flashToast("Error predicting remark", "warning");
    }
  }

  // Attach listeners to all medicine and description fields for remark prediction
  attachRemarkPredictionListeners() {
    // Only attach listeners if they haven't been attached yet
    if (this.constructor.listenersAttached) return;
    
    const controller = this;
    $(document).off('blur.remarkPredictor').on('blur.remarkPredictor', 'input[name="treatment_medicine[description]"]', function() {
      const $row = $(this).closest('tr');
      const isCarryforwarded = $row.attr('data-carryforwarded') === 'true';
      if (isCarryforwarded) {
        return;
      }

      const medicine = $row.find('input[name="treatment_medicine[name]"]').val();
      const description = $row.find('input[name="treatment_medicine[description]"]').val();
      const $remark = $row.find('input[name="treatment_medicine[remark]"]');
      const remark = $remark.val();
      // A remark that was already predicted stores its value in
      // data-original-prediction. If that's set, the doctor has DELIBERATELY
      // cleared the remark — don't re-predict (that caused "delete twice").
      // Only auto-predict the remark the first time (e.g. the wait-for-
      // description flow where the medicine had no remark prediction yet).
      const alreadyPredicted = !!$remark.attr('data-original-prediction');
      if (medicine && description && !remark && !alreadyPredicted) {
        controller.predictRemarksForMedicineRow($row[0]);
      }
    });

    // Mark listeners as attached
    this.constructor.listenersAttached = true;
  }

  // Patient Categories/Tags Methods
  loadPatientCategories(patientId) {
    console.log('loadPatientCategories called with patientId:', patientId);
    if (!patientId) {
      $('#patient-categories-container').hide();
      return;
    }
    
    this.currentPatientId = patientId;
    console.log('Set this.currentPatientId to:', this.currentPatientId);
    
    $.get(`/prescription/patient_categories?patient_id=${patientId}`)
      .done((data) => {
        console.log('Categories loaded successfully:', data);
        console.log('Patient categories received:', data.patient_categories);
        console.log('All categories received:', data.all_categories);
        
        // Store globally instead of using this
        window.patientCategories = data.patient_categories || [];
        window.allCategories = data.all_categories || [];
        
        console.log('Set window.allCategories to:', window.allCategories);
        console.log('Set window.patientCategories to:', window.patientCategories);
        this.renderCategories();
        $('#patient-categories-container').show();
      })
      .fail((xhr) => {
        console.error('Error loading patient categories:', xhr.responseText);
      });
  }

  renderCategories() {
    const container = $('#categories-tags-display');
    container.empty();
    
    const patientCategories = window.patientCategories || [];
    patientCategories.forEach((category) => {
      const tag = $(`
        <span class="category-tag">
          <span class="category-name">${this.escapeHtml(category)}</span>
          <span class="category-remove" data-category="${this.escapeHtml(category)}" data-action="click->prescription#removeCategory">×</span>
        </span>
      `);
      container.append(tag);
    });
  }

  searchCategories(event) {
    const searchTerm = event.target.value.trim();
    
    if (!this.categorySearchDebounced) {
      this.categorySearchDebounced = debounce((term) => {
        this.renderCategorySuggestions(term);
      }, 200);
    }
    
    if (searchTerm.length > 0) {
      this.categorySearchDebounced(searchTerm);
    } else {
      this.renderCategorySuggestions(''); // Show all categories when empty
    }
  }
  
  showCategorySuggestions(event) {
    let searchTerm = '';
    if (event && event.target) {
      searchTerm = event.target.value.trim();
    } else if (typeof event === 'string') {
      searchTerm = event; // For when called programmatically with a string
    }
    this.renderCategorySuggestions(searchTerm);
  }

  renderCategorySuggestions(searchTerm = '') {
    const suggestionsContainer = $('#categories-suggestions');
    suggestionsContainer.empty();
    
    const allCategories = window.allCategories || [];
    const patientCategories = window.patientCategories || [];
    
    console.log('Rendering suggestions for:', searchTerm);
    console.log('All categories:', allCategories);
    console.log('Patient categories:', patientCategories);
    
    if (!searchTerm) {
      // Show all existing categories that are NOT already applied to this patient
      allCategories.slice(0, 10).forEach((category) => {
        if (!patientCategories.includes(category)) {
          const item = $(`
            <div class="category-suggestion-item" data-category="${this.escapeHtml(category)}">
              ${this.escapeHtml(category)}
            </div>
          `);
          suggestionsContainer.append(item);
        }
      });
    } else {
      // Filter categories by search term (exclude already applied ones)
      console.log(`Searching for "${searchTerm}" in:`, allCategories);
      const filtered = allCategories.filter(cat => {
        const matches = cat.toLowerCase().includes(searchTerm.toLowerCase());
        const notAlreadyApplied = !patientCategories.includes(cat);
        console.log(`Category "${cat}": matches=${matches}, notAlreadyApplied=${notAlreadyApplied}`);
        return matches && notAlreadyApplied;
      });
      console.log('Filtered categories:', filtered);
      
      filtered.slice(0, 8).forEach((category) => {
        const item = $(`
          <div class="category-suggestion-item" data-category="${this.escapeHtml(category)}">
            ${this.escapeHtml(category)}
          </div>
        `);
        suggestionsContainer.append(item);
      });
      
      // Show "Create new" option if search term doesn't match existing
      if (filtered.length === 0 && !patientCategories.includes(searchTerm)) {
        const createItem = $(`
          <div class="category-suggestion-item create-new" data-category="${this.escapeHtml(searchTerm)}">
            Create new: "${this.escapeHtml(searchTerm)}"
          </div>
        `);
        suggestionsContainer.append(createItem);
      }
    }
    
    // Attach click handlers using jQuery instead of Stimulus data-action
    suggestionsContainer.find('.category-suggestion-item').on('click', (event) => {
      const category = $(event.currentTarget).attr('data-category');
      if (category) {
        this.addCategory(category);
        $('#categories-search-input').val('');
        $('#categories-suggestions').hide();
      }
    });
    
    if (suggestionsContainer.children().length > 0) {
      suggestionsContainer.show();
    } else {
      suggestionsContainer.hide();
    }
  }

  hideCategorySuggestions(event) {
    // Don't hide if user is clicking on a suggestion
    if (event && event.relatedTarget && $(event.relatedTarget).closest('#categories-suggestions').length > 0) {
      return;
    }
    
    // Delay to allow click events on suggestions
    setTimeout(() => {
      $('#categories-suggestions').hide();
    }, 150);
  }

  handleCategoryKeydown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      const searchInput = event.target;
      const searchTerm = searchInput.value.trim();
      
      if (searchTerm && !this.patientCategories.includes(searchTerm)) {
        this.addCategory(searchTerm);
        searchInput.value = '';
        $('#categories-suggestions').hide();
      }
    } else if (event.key === 'Escape') {
      $('#categories-suggestions').hide();
      event.target.blur();
    }
  }


  addCategory(categoryName) {
    // Get patient ID from DOM elements
    const patientId = $("#save_update, #saveprint").attr("data-patientId") || this.currentPatientId;
    
    if (!patientId || !categoryName) {
      console.log('Missing patient ID or category name:', {patientId, categoryName});
      flashToast("Please select a patient first", "warning");
      return;
    }
    
    const patientCategories = window.patientCategories || [];
    if (patientCategories.includes(categoryName)) {
      flashToast("Category already exists", "warning");
      return;
    }
    
    const HOST = window.location.origin;
    const TOKEN = window.TOKEN || window.readCookie("_priac_jwt");
    
    $.ajax({
      url: `${HOST}/api/v1/patients/${patientId}/add_category`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${TOKEN}`,
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      data: JSON.stringify({ category_name: categoryName })
    })
      .done((response) => {
        if (response.status && response.status.status === "SUCCESS") {
          window.patientCategories = response.payload.categories || [];
          this.renderCategories();
          flashToast(response.status.message || "Category added successfully", "success");
          // Category → outcome-measure mapping changed; refresh calculators live.
          this.loadOutcomeCalculators(patientId);

          // Update all categories list if new category was created
          const allCategories = window.allCategories || [];
          if (!allCategories.includes(categoryName)) {
            allCategories.push(categoryName);
            allCategories.sort();
            window.allCategories = allCategories;
          }
        } else {
          flashToast((response.status && response.status.message) || "Error adding category", "error");
        }
      })
      .fail((xhr) => {
        const errorMsg = xhr.responseJSON?.status?.message || "Error adding category";
        flashToast(errorMsg, "error");
      });
  }

  removeCategory(event) {
    const categoryName = $(event.currentTarget).attr('data-category');
    // Get patient ID from DOM elements
    const patientId = $("#save_update, #saveprint").attr("data-patientId") || this.currentPatientId;
    
    if (!patientId || !categoryName) {
      console.log('Missing patient ID or category name:', {patientId, categoryName});
      return;
    }
    
    const HOST = window.location.origin;
    const TOKEN = window.TOKEN || window.readCookie("_priac_jwt");
    
    $.ajax({
      url: `${HOST}/api/v1/patients/${patientId}/remove_category`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${TOKEN}`,
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      data: JSON.stringify({ category_name: categoryName })
    })
      .done((response) => {
        if (response.status && response.status.status === "SUCCESS") {
          window.patientCategories = response.payload.categories || [];
          this.renderCategories();
          flashToast(response.status.message || "Category removed successfully", "success");
          // Refresh outcome-measure calculators to match the new category set.
          this.loadOutcomeCalculators(patientId);
        } else {
          flashToast((response.status && response.status.message) || "Error removing category", "error");
        }
      })
      .fail((xhr) => {
        const errorMsg = xhr.responseJSON?.status?.message || "Error removing category";
        flashToast(errorMsg, "error");
      });
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // DAS28 Calculator Methods
  loadDas28Calculator(patientId) {
    this.loadOutcomeCalculators(patientId);
  }

  loadOutcomeCalculators(patientId) {
    if (!patientId) {
      $('#outcome-calculators-container').hide();
      return;
    }

    const block = this;

    $.get(`/prescription/patient_calculators?patient_id=${patientId}`)
      .done((data) => {
        const calculators = data.calculators || [];
        if (calculators.length === 0) {
          $('#outcome-calculators-container').hide();
          return;
        }

        let buttonsHtml = '';
        calculators.forEach(calc => {
          buttonsHtml += `
            <div class="mb-2">
              <button type="button" class="btn btn-sm btn-primary calculator-btn" data-calculator-type="${calc.type}" data-action="click->prescription#openCalculator">
                <i class="fa fa-stethoscope"></i> ${calc.name}
              </button>
              <button type="button" class="btn btn-sm btn-outline-secondary" data-calculator-type="${calc.type}" data-action="click->prescription#viewOutcomeHistory">
                <i class="fa fa-history"></i>
              </button>
              <div class="latest-outcome-score mt-1" data-calculator-type="${calc.type}" style="display: none;">
                <small class="text-muted">Latest: <span class="score-value"></span> — <span class="score-level"></span></small>
              </div>
            </div>`;
        });

        $('#calculator-buttons').html(buttonsHtml);
        $('#outcome-calculators-container').show();

        // Load latest scores for each calculator
        calculators.forEach(calc => {
          block.loadLatestOutcomeScore(patientId, calc.type);
        });
      })
      .fail(() => {
        $('#outcome-calculators-container').hide();
      });
  }

  loadLatestOutcomeScore(patientId, calculatorType) {
    $.get(`/prescription/latest_outcome?patient_id=${patientId}&calculator_type=${calculatorType}`)
      .done((data) => {
        const container = $(`.latest-outcome-score[data-calculator-type="${calculatorType}"]`);
        if (data.measure) {
          const score = data.measure.primary_score;
          const level = data.measure.activity_level;
          container.find('.score-value').text(score ? parseFloat(score).toFixed(2) : 'N/A');
          container.find('.score-level').text(level || '');
          container.show();
        } else {
          container.hide();
        }
      });
  }

  openCalculator(event) {
    const calculatorType = event.currentTarget.getAttribute('data-calculator-type') || 'das28';
    const patientId = $("#save_update, #saveprint").attr("data-patientId");
    const appointmentId = $("#save_update, #saveprint").attr("data-appointmentid");

    if (!patientId) {
      flashToast('Please select a patient first', 'warning');
      return;
    }

    const block = this;

    $.ajax({
      url: `/prescription/calculator?type=${calculatorType}`,
      headers: { "Authorization": `Token ${TOKEN}` },
      method: 'GET',
      success: function() {
        // Set patient info in the modal (generic selectors)
        let patientName = $('#patient_full_name').is('input') ? $('#patient_full_name').val() : $('#patient_full_name').text().trim();
        patientName = patientName || 'Unknown Patient';

        $('.calc-patient-name').text(patientName);
        $('.calc-patient-id').text(patientId);
        $('.calc-patient-id-hidden').val(patientId);
        $('.calc-appointment-id-hidden').val(appointmentId || '');
        $('.calc-type-hidden').val(calculatorType);

        // Also set DAS28-specific fields for backward compat
        $('#das28-patient-name').text(patientName);
        $('#das28-patient-id').text(patientId);
        $('#das28-patient-id-hidden').val(patientId);
        $('#das28-appointment-id-hidden').val(appointmentId || '');

        // The calculator .js.erb already renders + shows the modal; scope to the
        // container's modal so we never open other page modals (double-modal bug).
        $(".modal-container .modal").modal('show');
      },
      error: function(err) {
        console.error('Failed to load calculator:', err);
        flashToast('Error loading calculator', 'warning');
      }
    });
  }

  openDas28Calculator() {
    console.log('openDas28Calculator called');

    $.ajax({
      url: "/prescription/calculator",
      headers: { "Authorization": `Token ${TOKEN}` },
      method: 'GET',
      success: function(){
        
      
    
        // Get current patient info
        const patientId = $("#save_update, #saveprint").attr("data-patientId");
        const appointmentId = $("#save_update, #saveprint").attr("data-appointmentid");
        
        console.log('Patient ID found:', patientId);
        console.log('Appointment ID found:', appointmentId);
        
        // Try multiple ways to get patient name with more comprehensive selectors
        let patientName = 'Unknown Patient';
        
        // Get patient name from the patient_full_name element
        const patientFullNameElement = $('#patient_full_name');
        if (patientFullNameElement.length > 0) {
          // Check if it's an input field
          if (patientFullNameElement.is('input')) {
            patientName = patientFullNameElement.val() || 'Unknown Patient';
          } else {
            // Check if it's a text element
            patientName = patientFullNameElement.text().trim() || 'Unknown Patient';
          }
        }
        
        console.log('Patient full name element:', patientFullNameElement);
        console.log('Patient name from #patient_full_name:', patientName);

        console.log('Selected patient name:', patientName);
        console.log('Patient ID:', patientId);

        if (!patientId) {
          console.log('No patient ID found - showing alert');
          flashToast('Please select a patient first', 'warning');
          return;
        }
        
        console.log('Patient ID validation passed, proceeding...');

        // Set patient info in modal
        $('#das28-patient-name').text(patientName);
        $('#das28-patient-id').text(patientId);
        $('#das28-patient-id-hidden').val(patientId);
        $('#das28-appointment-id-hidden').val(appointmentId || '');

        console.log('Setting patient info in modal...');
        
        // Clear previous values
        const form = $('#das28CalculatorForm')[0];
        console.log('Form element found:', !!form);
        if (form) {
          console.log('Resetting form...');
          form.reset();
        } else {
          console.log('Form not found, clearing individual fields...');
          // If form doesn't exist, clear individual fields
          $('#das28CalculatorForm input').val('');
        }
        $('#das28-esr-result').text('-');
        $('#das28-crp-result').text('-');
        $('#das28-esr-level').text('Calculate to see result');
        $('#das28-crp-level').text('Calculate to see result');

        console.log('Setting up event handlers...');
        // Attach calculation event handlers
        const calculatorInstance = this;
        $('#das28CalculatorForm input[type="number"]').off('input.das28').on('input.das28', function() {
          calculatorInstance.updateDas28Calculation();
        });

        console.log('About to show modal...');
        console.log('Modal element exists:', $('#das28CalculatorModal').length > 0);
        console.log('Modal form exists:', $('#das28CalculatorModal #das28CalculatorForm').length > 0);

    
        // Show modal
        $('#das28CalculatorModal').modal('show');
        console.log('Modal show command executed');
      }
    })

  }

  updateDas28Calculation() {
    const tjc28 = parseFloat($('#das28CalculatorForm input[name="tjc28"]').val()) || 0;
    const sjc28 = parseFloat($('#das28CalculatorForm input[name="sjc28"]').val()) || 0;
    const esr = $('#das28CalculatorForm input[name="esr"]').val();
    const crp = $('#das28CalculatorForm input[name="crp"]').val();
    const globalHealth = parseFloat($('#das28CalculatorForm input[name="global_health"]').val()) || 0;
    
    console.log('DAS28 Calculation values:', {tjc28, sjc28, esr, crp, globalHealth});

    // Check if we have all required fields filled before attempting calculation
    const hasRequiredFields = tjc28 >= 0 && sjc28 >= 0 && globalHealth > 0;
    const hasLabValues = (esr && esr.trim() !== '' && parseFloat(esr) > 0) || 
                        (crp && crp.trim() !== '' && parseFloat(crp) >= 0);
    
    // Only calculate if we have all required values
    if (hasRequiredFields && hasLabValues) {
      const params = {
        tjc28: tjc28,
        sjc28: sjc28,
        global_health: globalHealth
      };

      if (esr && esr.trim() !== '' && parseFloat(esr) > 0) params.esr = parseFloat(esr);
      if (crp && crp.trim() !== '' && parseFloat(crp) >= 0) params.crp = parseFloat(crp);

      $.ajaxSetup({
        beforeSend: function(xhr) {
          xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
        }
      });
      
      console.log('Sending DAS28 calculation request with params:', params);
      
      $.post('/prescription/calculate_das28', params)
        .done((data) => {
          console.log('DAS28 calculation response:', data);
          
          // Update DAS28(ESR) result
          if (data.das28_esr_score !== null && data.das28_esr_score !== undefined) {
            const esrScore = parseFloat(data.das28_esr_score);
            if (!isNaN(esrScore)) {
              $('#das28-esr-result').text(esrScore.toFixed(2));
              $('#das28-esr-level').text(data.activity_level_description || data.activity_level || 'Calculated');
            } else {
              $('#das28-esr-result').text('-');
              $('#das28-esr-level').text('ESR value required');
            }
          } else {
            $('#das28-esr-result').text('-');
            $('#das28-esr-level').text('ESR value required');
          }

          // Update DAS28(CRP) result  
          if (data.das28_crp_score !== null && data.das28_crp_score !== undefined) {
            const crpScore = parseFloat(data.das28_crp_score);
            if (!isNaN(crpScore)) {
              $('#das28-crp-result').text(crpScore.toFixed(2));
              $('#das28-crp-level').text(data.activity_level_description || data.activity_level || 'Calculated');
            } else {
              $('#das28-crp-result').text('-');
              $('#das28-crp-level').text('CRP value required');
            }
          } else {
            $('#das28-crp-result').text('-');
            $('#das28-crp-level').text('CRP value required');
          }
        })
        .fail((xhr) => {
          console.error('DAS28 calculation failed:', xhr.responseText);
          console.error('Status:', xhr.status);
          $('#das28-esr-result').text('Error');
          $('#das28-crp-result').text('Error');
          $('#das28-esr-level').text('Calculation failed');
          $('#das28-crp-level').text('Calculation failed');
          
          // Show error message to user
          if (xhr.responseJSON && xhr.responseJSON.error) {
            alert('Error: ' + xhr.responseJSON.error);
          }
        });
    } else {
      // Reset display when not all required fields are filled
      $('#das28-esr-result').text('-');
      $('#das28-crp-result').text('-');
      
      // Show helpful guidance based on what's missing
      if (!hasRequiredFields) {
        $('#das28-esr-level').text('Enter all joint counts and global health');
        $('#das28-crp-level').text('Enter all joint counts and global health');
      } else if (!hasLabValues) {
        $('#das28-esr-level').text('Enter ESR value');
        $('#das28-crp-level').text('Enter CRP value');
      } else {
        $('#das28-esr-level').text('Calculate to see result');
        $('#das28-crp-level').text('Calculate to see result');
      }
    }
  }

  getActivityLevelColor(activityLevel) {
    const colors = {
      'remission': 'text-success',
      'low': 'text-info', 
      'moderate': 'text-warning',
      'high': 'text-danger'
    };
    return colors[activityLevel] || '';
  }

  saveDas28Score(event) {
    console.log('Save DAS28 Score clicked', event);
    
    // Prevent any default behavior
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    const form = $('#das28CalculatorForm')[0];
    const formData = new FormData(form);
    
    // Convert FormData to regular object and include hidden fields, excluding authenticity_token
    const params = {};
    formData.forEach((value, key) => {
      if (value && value.trim() !== '' && key !== 'authenticity_token') {
        params[key] = value;
      }
    });

    // Ensure patient_id is included from hidden field or data attributes
    if (!params.patient_id) {
      params.patient_id = $('#das28-patient-id-hidden').val() || $("#save_update, #saveprint").attr("data-patientId");
    }
    
    // Include appointment_id if available
    if (!params.appointment_id) {
      params.appointment_id = $('#das28-appointment-id-hidden').val() || $("#save_update, #saveprint").attr("data-appointmentid");
    }

    console.log('Form params for saving:', params);
    console.log('Patient ID:', params.patient_id);
    console.log('Appointment ID:', params.appointment_id);

    if (!params.patient_id) {
      alert('Patient ID is required. Please select a patient first.');
      return;
    }

    if (!params.tjc28 || !params.sjc28 || !params.global_health) {
      alert('Please fill in all required fields (TJC28, SJC28, Global Health)');
      return;
    }

    if (!params.esr && !params.crp) {
      alert('Please enter either ESR or CRP value');
      return;
    }

    console.log('Sending save request to /prescription/save_das28_score');

    $.ajax({
      url: '/prescription/save_das28_score',
      method: 'POST',
      headers: { "Authorization": `Token ${TOKEN}` },
      data: params,
      success: (data) => {
        console.log('DAS28 save response:', data);
        flashToast('DAS28 score saved successfully!', 'success');
        $('#das28CalculatorModal').modal('hide');
        
        // Refresh the latest score display
        const patientId = params.patient_id;
        this.loadLatestOutcomeScore(patientId, 'das28');
      },
      error: (xhr) => {
        console.error('DAS28 save failed:', xhr);
        console.error('Status:', xhr.status);
        console.error('Response:', xhr.responseText);
        const errorMsg = xhr.responseJSON?.error || xhr.responseText || 'Error saving DAS28 score';
        flashToast('Save failed: ' + errorMsg, 'warning');
      }
    });
  }

  viewDas28History() {
    const patientId = $("#save_update, #saveprint").attr("data-patientId");
    
    if (!patientId) {
      flashToast('Please select a patient first', 'warning');
      return;
    }

    $.get(`/prescription/das28_history?patient_id=${patientId}`)
      .done((data) => {
        this.showDas28History(data.scores);
      })
      .fail(() => {
        flashToast('Error loading DAS28 history', 'warning');
      });
  }

  showDas28History(scores) {
    let html = '<div class="modal fade" id="das28HistoryModal" tabindex="-1"><div class="modal-dialog modal-xl"><div class="modal-content">';
    html += '<div class="modal-header" style="background:linear-gradient(135deg,#0d5e6e,#1E9BB7);color:white;padding:12px 20px;">';
    html += '<h5 class="m-0"><i class="fa fa-history mr-2"></i>DAS-28 History</h5><button type="button" class="close text-white" data-dismiss="modal">&times;</button></div>';
    html += '<div class="modal-body" style="max-height:75vh;overflow-y:auto;padding:16px;">';

    if (!scores || scores.length === 0) {
      html += '<p class="text-center text-muted py-4">No history available</p>';
    } else {
      scores.forEach((score, idx) => {
        const esrScore = score.das28_esr_score ? parseFloat(score.das28_esr_score).toFixed(2) : null;
        const crpScore = score.das28_crp_score ? parseFloat(score.das28_crp_score).toFixed(2) : null;
        const displayScore = esrScore || crpScore || 'N/A';
        const badgeClass = this.getActivityBadgeClass(score.activity_level);
        const levelLabel = score.activity_level_description || score.activity_level || '-';

        const isExpanded = idx === 0 ? 'show' : '';
        const isCollapsed = idx === 0 ? '' : 'collapsed';

        html += `<div class="card mb-2" style="border:1px solid #e2e8f0;border-radius:8px;overflow:hidden;">`;
        html += `<div class="card-header p-0" style="background:#f8fafc;border-bottom:1px solid #e2e8f0;">
          <div class="${isCollapsed}" data-toggle="collapse" data-target="#das28Entry${idx}" style="cursor:pointer;padding:10px 16px;display:flex;justify-content:space-between;align-items:center;">
            <div style="display:flex;align-items:center;gap:12px;">
              <div style="font-size:13px;font-weight:600;color:#0f172a;">${score.calculated_at}</div>
              <div style="font-size:22px;font-weight:700;color:#1E9BB7;">${displayScore}</div>
              <span class="badge badge-${badgeClass}" style="font-size:11px;padding:4px 10px;">${levelLabel}</span>
            </div>
            <i class="fa fa-chevron-down" style="color:#94a3b8;font-size:11px;"></i>
          </div>
        </div>`;

        html += `<div id="das28Entry${idx}" class="collapse ${isExpanded}">
          <div class="card-body" style="padding:12px 16px;">
            <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:8px;">
              <div style="padding:8px 12px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:6px;">
                <div style="font-size:10px;color:#64748b;text-transform:uppercase;">TJC-28</div>
                <div style="font-size:16px;font-weight:700;color:#0f172a;">${score.tjc28}</div>
              </div>
              <div style="padding:8px 12px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:6px;">
                <div style="font-size:10px;color:#64748b;text-transform:uppercase;">SJC-28</div>
                <div style="font-size:16px;font-weight:700;color:#0f172a;">${score.sjc28}</div>
              </div>
              <div style="padding:8px 12px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:6px;">
                <div style="font-size:10px;color:#64748b;text-transform:uppercase;">ESR</div>
                <div style="font-size:16px;font-weight:700;color:#0f172a;">${score.esr || '-'}</div>
              </div>
              <div style="padding:8px 12px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:6px;">
                <div style="font-size:10px;color:#64748b;text-transform:uppercase;">CRP</div>
                <div style="font-size:16px;font-weight:700;color:#0f172a;">${score.crp || '-'}</div>
              </div>
              <div style="padding:8px 12px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:6px;">
                <div style="font-size:10px;color:#64748b;text-transform:uppercase;">Global Health</div>
                <div style="font-size:16px;font-weight:700;color:#0f172a;">${score.global_health}</div>
              </div>
              ${esrScore ? `<div style="padding:8px 12px;background:#eef9ff;border:1px solid #bae6fd;border-radius:6px;">
                <div style="font-size:10px;color:#0369a1;text-transform:uppercase;">DAS28 (ESR)</div>
                <div style="font-size:16px;font-weight:700;color:#0369a1;">${esrScore}</div>
              </div>` : ''}
              ${crpScore ? `<div style="padding:8px 12px;background:#eef9ff;border:1px solid #bae6fd;border-radius:6px;">
                <div style="font-size:10px;color:#0369a1;text-transform:uppercase;">DAS28 (CRP)</div>
                <div style="font-size:16px;font-weight:700;color:#0369a1;">${crpScore}</div>
              </div>` : ''}
            </div>
          </div>
        </div></div>`;
      });
    }

    html += '</div><div class="modal-footer" style="padding:10px 20px;border-top:1px solid #e2e8f0;">';
    html += '<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Close</button></div>';
    html += '</div></div></div>';

    $('#das28HistoryModal').remove();
    $(".modal").modal('hide');
    $('.modal-container').html(html);
    $('#das28HistoryModal').modal('show');
  }

  getActivityBadgeClass(activityLevel) {
    const classes = {
      'remission': 'success',
      'low': 'info',
      'moderate': 'warning', 
      'high': 'danger'
    };
    return classes[activityLevel] || 'secondary';
  }

  viewOutcomeHistory(event) {
    const calculatorType = event.currentTarget.getAttribute('data-calculator-type');
    const patientId = $("#save_update, #saveprint").attr("data-patientId");

    if (!patientId) {
      flashToast('Please select a patient first', 'warning');
      return;
    }

    // DAS28 has its own separate data model and handler
    if (calculatorType === 'das28') {
      this.viewDas28History();
      return;
    }

    const calcName = OutcomeMeasure_NAMES[calculatorType] || calculatorType;

    const block = this;
    $.get(`/prescription/outcome_history?patient_id=${patientId}&calculator_type=${calculatorType}`)
      .done((data) => {
        const measures = data.measures || [];
        let html = `<div class="modal fade" id="outcomeHistoryModal" tabindex="-1"><div class="modal-dialog modal-xl"><div class="modal-content">`;
        html += `<div class="modal-header" style="background:linear-gradient(135deg,#0d5e6e,#1E9BB7);color:white;padding:12px 20px;">`;
        html += `<h5 class="m-0"><i class="fa fa-history mr-2"></i>${calcName} History</h5><button type="button" class="close text-white" data-dismiss="modal">&times;</button></div>`;
        html += `<div class="modal-body" style="max-height:75vh;overflow-y:auto;padding:16px;">`;

        if (measures.length === 0) {
          html += `<p class="text-center text-muted py-4">No history available</p>`;
        } else {
          measures.forEach((m, idx) => {
            const score = m.results?.primary_score ? parseFloat(m.results.primary_score).toFixed(1) : 'N/A';
            const level = m.results?.activity_level || '-';
            const badgeClass = block.getActivityBadgeClass(level);
            const levelLabel = level.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

            // Separate true (active) and false (inactive) items
            const activeItems = [];
            const inactiveItems = [];
            Object.entries(m.inputs || {}).forEach(([k, v]) => {
              const label = k.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
              if (v === true || v === 'true') activeItems.push(label);
              else inactiveItems.push(label);
            });

            const isExpanded = idx === 0 ? 'show' : '';
            const isCollapsed = idx === 0 ? '' : 'collapsed';

            html += `<div class="card mb-2" style="border:1px solid #e2e8f0;border-radius:8px;overflow:hidden;">`;
            // Card header — clickable accordion
            html += `<div class="card-header p-0" style="background:#f8fafc;border-bottom:1px solid #e2e8f0;">
              <div class="${isCollapsed}" data-toggle="collapse" data-target="#historyEntry${idx}" style="cursor:pointer;padding:10px 16px;display:flex;justify-content:space-between;align-items:center;">
                <div style="display:flex;align-items:center;gap:12px;">
                  <div style="font-size:13px;font-weight:600;color:#0f172a;">${m.calculated_at}</div>
                  <div style="font-size:22px;font-weight:700;color:#1E9BB7;">${score}</div>
                  <span class="badge badge-${badgeClass}" style="font-size:11px;padding:4px 10px;">${levelLabel}</span>
                </div>
                <div style="display:flex;align-items:center;gap:8px;">
                  ${activeItems.length > 0 ? `<span style="font-size:11px;color:#64748b;">${activeItems.length} active</span>` : ''}
                  <i class="fa fa-chevron-down" style="color:#94a3b8;font-size:11px;"></i>
                </div>
              </div>
            </div>`;

            // Collapsible body
            html += `<div id="historyEntry${idx}" class="collapse ${isExpanded}">
              <div class="card-body" style="padding:12px 16px;">`;

            if (activeItems.length > 0) {
              html += `<div class="mb-2"><small class="text-uppercase font-weight-bold" style="color:#dc2626;letter-spacing:0.5px;">Present</small></div>`;
              html += `<div style="display:flex;flex-wrap:wrap;gap:4px;margin-bottom:10px;">`;
              activeItems.forEach(item => {
                html += `<span style="display:inline-block;padding:3px 10px;background:#fef2f2;border:1px solid #fecaca;border-radius:4px;font-size:11px;color:#991b1b;font-weight:500;">${item}</span>`;
              });
              html += `</div>`;
            }

            if (inactiveItems.length > 0) {
              html += `<div class="mb-2"><small class="text-uppercase font-weight-bold" style="color:#16a34a;letter-spacing:0.5px;">Absent</small></div>`;
              html += `<div style="display:flex;flex-wrap:wrap;gap:4px;">`;
              inactiveItems.forEach(item => {
                html += `<span style="display:inline-block;padding:3px 10px;background:#f0fdf4;border:1px solid #bbf7d0;border-radius:4px;font-size:11px;color:#166534;">${item}</span>`;
              });
              html += `</div>`;
            }

            // For non-boolean inputs (DAS28 etc) show as key-value
            const numericInputs = Object.entries(m.inputs || {}).filter(([k, v]) => v !== true && v !== false && v !== 'true' && v !== 'false');
            if (numericInputs.length > 0 && activeItems.length === 0 && inactiveItems.length === 0) {
              html += `<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(180px,1fr));gap:6px;">`;
              numericInputs.forEach(([k, v]) => {
                const label = k.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
                html += `<div style="padding:6px 10px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:4px;">
                  <div style="font-size:10px;color:#64748b;text-transform:uppercase;">${label}</div>
                  <div style="font-size:13px;font-weight:600;color:#0f172a;">${v}</div>
                </div>`;
              });
              html += `</div>`;
            }

            html += `</div></div></div>`;
          });
        }

        html += `</div><div class="modal-footer" style="padding:10px 20px;border-top:1px solid #e2e8f0;">`;
        html += `<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Close</button></div>`;
        html += `</div></div></div>`;

        $('#outcomeHistoryModal').remove();
        $(".modal").modal('hide');
        $('.modal-container').html(html);
        $('#outcomeHistoryModal').modal('show');
      })
      .fail(() => {
        flashToast('Error loading history', 'warning');
      });
  }

  // Chatbot widget methods
  toggleChatbot() {
    const chatWindow = $('#chatbot-window');
    
    if (chatWindow.is(':visible')) {
      this.closeChatbot();
    } else {
      chatWindow.show();
      this.loadChatbotEnquiries();
    }
  }

  minimizeChatbot() {
    const chatWindow = $('#chatbot-window');
    chatWindow.hide();
  }

  closeChatbot() {
    const chatWindow = $('#chatbot-window');
    chatWindow.hide();
    
    // Reset to enquiries list view
    $('#enquiries-list-view').show();
    $('#chat-view').hide();
  }

  backToEnquiriesList() {
    $('#chat-view').hide();
    $('#enquiries-list-view').show();
  }

  loadChatbotEnquiries() {
    console.log('Loading chatbot enquiries...');
    $('#enquiries-loading-chatbot').show();
    $('#enquiries-empty-chatbot').hide();
    $('#chatbot-enquiries-list').empty();

    const HOST = window.location.origin;
    const TOKEN = window.TOKEN || window.readCookie("_priac_jwt");

    fetch(`${HOST}/prescription/enquiries_list`, {
      headers: { "Authorization": `Token ${TOKEN}` }
    })
      .then(response => response.json())
      .then(data => {
        $('#enquiries-loading-chatbot').hide();
        
        if (data.enquiries && data.enquiries.length > 0) {
          this.renderChatbotEnquiries(data.enquiries);
          // Apply default "open" filter
          this.applyDefaultFilter();
        } else {
          $('#chatbot-enquiries-count').text(0);
          $('#enquiries-empty-chatbot').show();
        }
      })
      .catch(error => {
        console.error('Error loading enquiries:', error);
        $('#enquiries-loading-chatbot').hide();
        $('#enquiries-empty-chatbot').show();
        if (typeof flashToast !== 'undefined') {
          flashToast("Error loading enquiries", "error");
        }
      });
  }

  renderChatbotEnquiries(enquiries) {
    const container = $('#chatbot-enquiries-list');
    container.empty();

    enquiries.forEach(enquiry => {
      const statusBadge = this.getEnquiryStatusBadge(enquiry.status);
      const timeAgo = this.getTimeAgo(enquiry.created_at);
      const messagePreview = enquiry.message ? enquiry.message.substring(0, 60) : '';

      const enquiryItem = `
        <div class="enquiry-item-chatbot"
             data-patient-id="${enquiry.patient.id}"
             data-status="${enquiry.status}"
             data-action="click->prescription#selectChatbotEnquiry">
          <div class="enquiry-patient-name">${enquiry.patient.full_name} (${enquiry.patient.uid})</div>
          <div class="enquiry-preview">${messagePreview}...</div>
          <div class="enquiry-meta">
            <span class="enquiry-time">${timeAgo}</span>
            ${statusBadge}
          </div>
        </div>`;

      container.append(enquiryItem);
    });
  }

  getEnquiryStatusBadge(status) {
    const badges = {
      'open': '<span class="badge-sm badge badge-warning">Open</span>',
      'in_progress': '<span class="badge-sm badge badge-info">In Progress</span>',
      'resolved': '<span class="badge-sm badge badge-success">Resolved</span>',
      'closed': '<span class="badge-sm badge badge-secondary">Closed</span>'
    };
    return badges[status] || '<span class="badge-sm badge badge-secondary">Unknown</span>';
  }

  getTimeAgo(dateString) {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor(diffTime / (1000 * 60 * 60));
    const diffMinutes = Math.floor(diffTime / (1000 * 60));

    if (diffDays > 0) return `${diffDays}d ago`;
    if (diffHours > 0) return `${diffHours}h ago`;
    if (diffMinutes > 0) return `${diffMinutes}m ago`;
    return 'Just now';
  }

  selectChatbotEnquiry(event) {
    const patientId = event.currentTarget.getAttribute('data-patient-id');

    if (!patientId) return;

    // Highlight selected enquiry
    document.querySelectorAll('.enquiry-item-chatbot').forEach(item => {
      item.classList.remove('active');
    });
    event.currentTarget.classList.add('active');

    // Create a synthetic event to mimic proper patient selection
    const syntheticEvent = {
      target: $(`<div data-patientid="${patientId}"></div>`)[0]
    };

    // Use the proper fillPatient method that loads everything
    this.fillPatient(syntheticEvent);

    // Show chat view using patient_id
    this.showChatbotChat(null, patientId);
  }

  showChatbotChat(enquiryId, patientId) {
    // Switch to chat view
    $('#enquiries-list-view').hide();
    $('#chat-view').show();
    
    const chatContent = $('#chatbot-chat-messages');
    const patientNameSpan = $('#chat-patient-name');
    
    // Store current patient ID for sending messages
    $('#enquiry-chatbot-widget').attr('data-current-patient-id', patientId);
    if (enquiryId) $('#enquiry-chatbot-widget').attr('data-current-enquiry-id', enquiryId);

    // Load chat thread
    chatContent.html('<div class="text-center p-3">Loading conversation...</div>');

    const HOST = window.location.origin;
    const TOKEN = window.TOKEN || window.readCookie("_priac_jwt");

    const url = patientId
      ? `${HOST}/prescription/query_messages?patient_id=${patientId}`
      : `${HOST}/prescription/query_messages?id=${enquiryId}`;

    fetch(url, {
      headers: { "Authorization": `Token ${TOKEN}` }
    })
      .then(response => response.json())
      .then(data => {
        chatContent.empty();
        
        // Update patient name and subject
        patientNameSpan.text(data.query.patient.full_name);
        $('#chat-enquiry-subject').text(data.query.subject);
        
        // Show/hide resolve button based on status
        const resolveBtn = $('#resolve-enquiry-btn');
        if (data.query.status === 'open' || data.query.status === 'in_progress') {
          resolveBtn.show().attr('data-query-id', data.query.id);
        } else {
          resolveBtn.hide();
        }
        
        // Render messages
        if (data.messages && data.messages.length > 0) {
          data.messages.forEach(message => {
            const messageClass = message.sender_type === 'patient' ? 'patient' : 'specialist';
            const metaClass = message.sender_type === 'patient' ? 'text-muted' : 'text-light';
            
            let attachmentsHtml = '';
            if (message.attachments && message.attachments.length > 0) {
              attachmentsHtml = '<div class="message-attachments mt-2">';
              message.attachments.forEach(attachment => {
                if (attachment.content_type && attachment.content_type.includes('image')) {
                  attachmentsHtml += `<div class="attachment-item"><img src="${attachment.url}" class="img-thumbnail" style="max-width: 200px; cursor: pointer;" onclick="window.open('${attachment.url}', '_blank')"></div>`;
                } else if (attachment.content_type && attachment.content_type.includes('audio')) {
                  attachmentsHtml += `<div class="attachment-item"><audio controls><source src="${attachment.url}" type="${attachment.content_type}"></audio></div>`;
                } else {
                  attachmentsHtml += `<div class="attachment-item"><a href="${attachment.url}" target="_blank" class="btn btn-sm btn-outline-primary"><i class="fa fa-paperclip"></i> ${attachment.filename || 'Attachment'}</a></div>`;
                }
              });
              attachmentsHtml += '</div>';
            }
            
            const messageHtml = `
              <div class="chat-message ${messageClass}">
                <div class="message-content">${message.message}</div>
                ${attachmentsHtml}
                <div class="message-meta">
                  <small class="${metaClass}" style="opacity: 0.8;">${message.timestamp}</small>
                </div>
              </div>`;
            chatContent.append(messageHtml);
          });
        } else {
          chatContent.html('<div class="text-center p-3 text-muted">No messages yet.</div>');
        }
        
        this.scrollChatToBottom(chatContent[0]);
      })
      .catch(error => {
        chatContent.html('<div class="text-center p-3 text-danger">Error loading conversation.</div>');
        console.error('Error loading chat thread:', error);
      });
  }

  loadChatMessages(enquiryId) {
    const chatContent = $('#chatbot-chat-messages');
    const HOST = window.location.origin;
    const TOKEN = window.TOKEN || window.readCookie("_priac_jwt");
    
    fetch(`${HOST}/prescription/query_messages?id=${enquiryId}`, {
      headers: { "Authorization": `Token ${TOKEN}` }
    })
      .then(response => response.json())
      .then(data => {
        chatContent.empty();
        
        // Render messages
        if (data.messages && data.messages.length > 0) {
          data.messages.forEach(message => {
            const messageClass = message.sender_type === 'patient' ? 'patient' : 'specialist';
            const metaClass = message.sender_type === 'patient' ? 'text-muted' : 'text-light';
            
            let attachmentsHtml = '';
            if (message.attachments && message.attachments.length > 0) {
              attachmentsHtml = '<div class="message-attachments mt-2">';
              message.attachments.forEach(attachment => {
                if (attachment.content_type && attachment.content_type.includes('image')) {
                  attachmentsHtml += `<div class="attachment-item"><img src="${attachment.url}" class="img-thumbnail" style="max-width: 200px; cursor: pointer;" onclick="window.open('${attachment.url}', '_blank')"></div>`;
                } else if (attachment.content_type && attachment.content_type.includes('audio')) {
                  attachmentsHtml += `<div class="attachment-item"><audio controls><source src="${attachment.url}" type="${attachment.content_type}"></audio></div>`;
                } else {
                  attachmentsHtml += `<div class="attachment-item"><a href="${attachment.url}" target="_blank" class="btn btn-sm btn-outline-primary"><i class="fa fa-paperclip"></i> ${attachment.filename || 'Attachment'}</a></div>`;
                }
              });
              attachmentsHtml += '</div>';
            }
            
            const messageHtml = `
              <div class="chat-message ${messageClass}">
                <div class="message-content">${message.message}</div>
                ${attachmentsHtml}
                <div class="message-meta">
                  <small class="${metaClass}" style="opacity: 0.8;">${message.timestamp}</small>
                </div>
              </div>`;
            chatContent.append(messageHtml);
          });
        } else {
          chatContent.html('<div class="text-center p-3 text-muted">No messages yet.</div>');
        }
        
        this.scrollChatToBottom(chatContent[0]);
      })
      .catch(error => {
        console.error('Error reloading messages:', error);
      });
  }

  handleChatbotKeydown(event) {
    // Ctrl+Enter or Cmd+Enter to send (better UX for textarea)
    if (event.key === 'Enter' && (event.ctrlKey || event.metaKey)) {
      event.preventDefault();
      this.sendChatbotMessage();
    }
    // Plain Enter just adds new line (normal textarea behavior)
  }

  sendChatbotMessage(event) {
    if (event) event.preventDefault();

    const widget = $('#enquiry-chatbot-widget');
    const enquiryId = widget.attr('data-current-enquiry-id');
    const messageInput = document.getElementById('chatbot-message-input');
    const sendBtn = document.getElementById('send-chatbot-message');
    const message = messageInput.value.trim();

    // Stop any active recording first
    if (this.chatbotIsRecording) {
      this.toggleChatbotRecording({ preventDefault: () => {} });
    }

    // Validate: need message or files
    if (!message && (!this.chatbotFiles || this.chatbotFiles.length === 0)) {
      if (typeof flashToast !== 'undefined') flashToast("Please enter a message or select files to send.", "warning");
      return;
    }

    // Disable inputs
    messageInput.disabled = true;
    if (sendBtn) sendBtn.disabled = true;

    const TOKEN = window.TOKEN || window.readCookie("_priac_jwt");
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

    const currentPatientId = widget.attr('data-current-patient-id');

    const formData = new FormData();
    formData.append('message', message);
    if (currentPatientId) formData.append('patient_id', currentPatientId);
    if (enquiryId) formData.append('enquiry_id', enquiryId);

    // Add files if available
    if (this.chatbotFiles && this.chatbotFiles.length > 0) {
      this.chatbotFiles.forEach(file => {
        formData.append('attachments[]', file);
      });
    }

    fetch('/prescription/send_chatbot_message', {
      method: 'POST',
      headers: {
        'Authorization': `Token ${TOKEN}`,
        'X-CSRF-Token': csrfToken
      },
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        messageInput.value = '';
        this.chatbotFiles = [];
        this.updateChatbotFilePreview();
        // Reload messages by patient_id
        if (currentPatientId) {
          this.showChatbotChat(null, currentPatientId);
        } else {
          const eid = enquiryId || data.query_id;
          if (eid) this.loadChatMessages(eid);
        }
        if (typeof flashToast !== 'undefined') flashToast("Message sent!", "success");
      } else {
        if (typeof flashToast !== 'undefined') flashToast(data.error || "Failed to send message", "error");
      }
    })
    .catch(error => {
      console.error('Error sending message:', error);
      if (typeof flashToast !== 'undefined') flashToast("Error sending message. Please try again.", "error");
    })
    .finally(() => {
      messageInput.disabled = false;
      if (sendBtn) sendBtn.disabled = false;
      messageInput.focus();
    });
  }

  applyDefaultFilter() {
    // Apply "open" filter by default
    const openTab = document.querySelector('.filter-tab[data-status="open"]');
    if (openTab) {
      // Simulate click on open tab to apply filter
      openTab.click();
    }
  }

  filterEnquiries(event) {
    const filterStatus = event.currentTarget.getAttribute('data-status');
    
    // Update active button
    document.querySelectorAll('.filter-tab').forEach(btn => {
      btn.classList.remove('active');
    });
    event.currentTarget.classList.add('active');
    
    // Filter enquiry items
    const enquiryItems = document.querySelectorAll('.enquiry-item-chatbot');
    let visibleCount = 0;
    
    enquiryItems.forEach(item => {
      const itemStatus = item.getAttribute('data-status');

      if (filterStatus === 'all' || itemStatus === filterStatus) {
        item.style.display = 'block';
        visibleCount++;
      } else {
        item.style.display = 'none';
      }
    });
    
    // Update count
    $('#chatbot-enquiries-count').text(visibleCount);
  }

  getBadgeStatus(badgeElement) {
    if (!badgeElement) return 'unknown';
    const text = badgeElement.textContent.toLowerCase();
    
    switch(text) {
      case 'open': return 'open';
      case 'in progress': return 'in_progress';
      case 'resolved': return 'resolved';
      case 'closed': return 'closed';
      default: return 'unknown';
    }
  }

  resolveEnquiry(event) {
    const enquiryId = event.currentTarget.getAttribute('data-query-id');
    
    if (!enquiryId) return;
    
    if (!confirm('Are you sure you want to resolve this enquiry?')) return;
    
    const HOST = window.location.origin;
    const TOKEN = window.TOKEN || window.readCookie("_priac_jwt");
    
    fetch(`${HOST}/prescription/resolve_enquiry`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${TOKEN}`,
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      },
      body: JSON.stringify({ query_id: enquiryId })
    })
      .then(response => {
        console.log('Response status:', response.status);
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
      })
      .then(data => {
        console.log('Resolve response:', data);
        // Check if operation was successful - be more permissive
        if (data.success === true || data.success === 'true' || !data.hasOwnProperty('success')) {
          // Hide resolve button safely
          if (event.currentTarget) {
            event.currentTarget.style.display = 'none';
          }
          
          // Show success message with multiple fallbacks
          try {
            if (typeof flashToast !== 'undefined') {
              flashToast("Enquiry resolved successfully", "info");
            } else if (typeof window.showToast !== 'undefined') {
              window.showToast("Enquiry resolved successfully", "success");
            } else if (typeof toastr !== 'undefined') {
              toastr.success("Enquiry resolved successfully");
            } else {
              // Final fallback - browser alert
              alert("Enquiry resolved successfully");
            }
          } catch (toastError) {
            console.warn('Toast notification failed:', toastError);
            alert("Enquiry resolved successfully");
          }
          
          // Go back to enquiries list and reload
          this.backToEnquiriesList();
          this.loadChatbotEnquiries();
        } else {
          console.log('Resolution failed:', data);
          try {
            if (typeof flashToast !== 'undefined') {
              flashToast(data.error || "Error resolving enquiry", "error");
            } else if (typeof window.showToast !== 'undefined') {
              window.showToast(data.error || "Error resolving enquiry", "error");
            } else if (typeof toastr !== 'undefined') {
              toastr.error(data.error || "Error resolving enquiry");
            } else {
              alert("Error: " + (data.error || "Error resolving enquiry"));
            }
          } catch (toastError) {
            console.warn('Toast notification failed:', toastError);
            alert("Error: " + (data.error || "Error resolving enquiry"));
          }
        }
      })
      .catch(error => {
        console.error('Error resolving enquiry:', error);
        try {
          if (typeof flashToast !== 'undefined') {
            flashToast("Error resolving enquiry", "error");
          } else if (typeof window.showToast !== 'undefined') {
            window.showToast("Error resolving enquiry", "error");
          } else if (typeof toastr !== 'undefined') {
            toastr.error("Error resolving enquiry");
          } else {
            alert("Error resolving enquiry");
          }
        } catch (toastError) {
          console.warn('Toast notification failed:', toastError);
          alert("Error resolving enquiry");
        }
      });
  }

  autoResize(event) {
    const textarea = event.target;
    textarea.style.height = 'auto';
    textarea.style.height = Math.min(textarea.scrollHeight, 120) + 'px';
  }

  handleFeedbackKeydown(event) {
    // Handle Enter or Space key to trigger feedback field
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.showFeedbackField(event);
    }
    // Tab key handling is now done by script.js keydown event
  }

  showFeedbackField(event) {
    event.preventDefault();
    const link = event.currentTarget;
    const feedbackSection = link.closest('.feedback-section');
    const feedbackTextarea = feedbackSection.querySelector('.feedback-textarea');
    
    // Show the feedback textarea
    feedbackTextarea.style.display = 'block';
    
    // Hide the "wrong?" link
    link.style.display = 'none';
    
    // Focus on the textarea
    const textarea = feedbackTextarea.querySelector('textarea');
    textarea.focus();
  }

  // Track original predicted values and show feedback links when modified
  setupFieldChangeDetection(row) {
    const descriptionField = row.querySelector('input[name="treatment_medicine[description]"]');
    const remarkField = row.querySelector('input[name="treatment_medicine[remark]"]');
    
    if (descriptionField) {
      // Store original value when prediction is set
      descriptionField.addEventListener('input', (e) => {
        this.checkFieldModification(e.target, 'description');
      });
    }
    
    if (remarkField) {
      // Store original value when prediction is set
      remarkField.addEventListener('input', (e) => {
        this.checkFieldModification(e.target, 'remark');
      });
    }
  }
  
  checkFieldModification(field, fieldType) {
    const row = field.closest('tr');
    const feedbackLink = row.querySelector(`.feedback-link[data-field-type="${fieldType}"]`);

    if (!feedbackLink) return;

    const originalValue = field.getAttribute('data-original-prediction');
    const noPrediction = field.getAttribute('data-no-prediction') === 'true';
    const currentValue = field.value.trim();

    if (noPrediction && currentValue) {
      // No prediction existed — doctor typed fresh — offer to save as default
      feedbackLink.style.display = 'inline';
      feedbackLink.tabIndex = 0;
      feedbackLink.textContent = 'Save as default?';
      feedbackLink.setAttribute('data-save-mode', 'new');
    } else if (originalValue && currentValue && currentValue !== originalValue) {
      // Had prediction, doctor changed it — offer correction feedback
      feedbackLink.style.display = 'inline';
      feedbackLink.tabIndex = 0;
      feedbackLink.textContent = 'wrong?';
      feedbackLink.removeAttribute('data-save-mode');
    } else {
      feedbackLink.style.display = 'none';
      feedbackLink.tabIndex = -1;
    }
  }

  saveFeedback(event) {
    const textarea = event.currentTarget;
    const feedbackText = textarea.value.trim();
    
    // Don't save if empty
    if (!feedbackText) {
      return;
    }

    const row = textarea.closest('tr');
    const fieldType = textarea.getAttribute('data-field-type');
    const medicineName = row.querySelector('input[name="treatment_medicine[name]"]').value;
    const fieldSelector = fieldType === 'description' 
      ? 'input[name="treatment_medicine[description]"]'
      : 'input[name="treatment_medicine[remark]"]';
    
    // Get the original prediction from data attribute (not current value!)
    const fieldElement = row.querySelector(fieldSelector);
    const oldPrediction = fieldElement.getAttribute('data-original-prediction') || '';
    const correctedValue = fieldElement.value; // Current value is the correction
    const isNewSave = fieldElement.getAttribute('data-no-prediction') === 'true';

    // Get appointment ID from submit buttons or URL parameters
    let appointmentId = $("#save_update, #saveprint").attr("data-appointmentid");
    if (!appointmentId) {
      const urlParams = new URLSearchParams(window.location.search);
      appointmentId = urlParams.get('appointment_id');
    }

    if (!appointmentId || !medicineName || (!isNewSave && !oldPrediction)) {
      console.error('Missing required data for feedback:', {
        appointmentId: appointmentId,
        medicineName: medicineName,
        oldPrediction: oldPrediction,
        fieldType: fieldType
      });
      if (typeof flashToast !== 'undefined') {
        flashToast("Unable to save feedback - missing required information", "warning");
      }
      return;
    }

    // Prepare data
    const feedbackData = {
      appointment_id: appointmentId,
      medicine_name: medicineName,
      field_type: fieldType,
      old_prediction: oldPrediction,
      corrected_value: correctedValue,
      feedback_text: feedbackText
    };

    // Save feedback via AJAX
    fetch('/prescription/save_prediction_feedback', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: JSON.stringify(feedbackData)
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        // Success feedback
        if (typeof flashToast !== 'undefined') {
          flashToast("Feedback saved successfully", "info");
        }
        
        // Hide the feedback textarea and show "wrong?" link again
        const feedbackSection = textarea.closest('.feedback-section');
        const feedbackTextarea = feedbackSection.querySelector('.feedback-textarea');
        const link = feedbackSection.querySelector('.feedback-link');
        
        feedbackTextarea.style.display = 'none';
        link.style.display = 'inline';
        
        // Clear the textarea
        textarea.value = '';
        
      } else {
        console.error('Error saving feedback:', data.error);
        if (typeof flashToast !== 'undefined') {
          flashToast("Error saving feedback: " + (data.error || "Unknown error"), "warning");
        }
      }
    })
    .catch(error => {
      console.error('Network error saving feedback:', error);
      if (typeof flashToast !== 'undefined') {
        flashToast("Network error saving feedback", "warning");
      }
    });
  }

  // File upload methods for chatbot
  triggerChatbotFileInput(event) {
    event.preventDefault();
    document.getElementById('chatbot-file-input').click();
  }

  handleChatbotFileSelection(event) {
    const files = Array.from(event.target.files);
    const validFiles = [];
    const maxSize = 10 * 1024 * 1024; // 10MB limit

    files.forEach(file => {
      // Validate file type
      const isImage = file.type.startsWith('image/');
      const isPDF = file.type === 'application/pdf';
      
      if (!isImage && !isPDF) {
        flashToast(`File "${file.name}" is not supported. Only images and PDFs are allowed.`, "warning");
        return;
      }

      // Validate file size
      if (file.size > maxSize) {
        flashToast(`File "${file.name}" is too large. Maximum size is 10MB.`, "warning");
        return;
      }

      validFiles.push(file);
    });

    // Add valid files to storage
    this.chatbotFiles = [...this.chatbotFiles, ...validFiles];
    this.updateChatbotFilePreview();
    
    // Clear the input
    event.target.value = '';
  }

  updateChatbotFilePreview() {
    const previewContainer = document.getElementById('chatbot-file-preview');
    const previewList = previewContainer.querySelector('.file-preview-list');
    
    if (this.chatbotFiles.length === 0) {
      previewContainer.style.display = 'none';
      return;
    }

    previewContainer.style.display = 'block';
    previewList.innerHTML = '';

    this.chatbotFiles.forEach((file, index) => {
      const fileItem = document.createElement('div');
      fileItem.className = 'file-preview-item';
      
      if (file.type.startsWith('image/')) {
        fileItem.className += ' image-preview';
        const reader = new FileReader();
        reader.onload = (e) => {
          fileItem.innerHTML = `
            <img src="${e.target.result}" class="preview-thumbnail" alt="Preview">
            <span class="file-name">${file.name}</span>
            <span class="file-size">${this.formatFileSize(file.size)}</span>
            <button type="button" class="btn btn-link btn-sm p-0 ml-1 text-danger" data-action="click->prescription#removeFileFromChatbot" data-index="${index}">
              <i class="fa fa-times"></i>
            </button>
          `;
        };
        reader.readAsDataURL(file);
      } else if (file.type.startsWith('audio/')) {
        fileItem.className += ' audio-preview';
        const audioUrl = URL.createObjectURL(file);
        fileItem.innerHTML = `
          <i class="fa fa-microphone file-icon text-danger"></i>
          <audio controls src="${audioUrl}"></audio>
          <button type="button" class="btn btn-link btn-sm p-0 ml-1 text-danger" data-action="click->prescription#removeFileFromChatbot" data-index="${index}">
            <i class="fa fa-times"></i>
          </button>
        `;
      } else {
        fileItem.innerHTML = `
          <i class="fa fa-file-pdf-o file-icon"></i>
          <span class="file-name">${file.name}</span>
          <span class="file-size">${this.formatFileSize(file.size)}</span>
          <button type="button" class="btn btn-link btn-sm p-0 ml-1 text-danger" data-action="click->prescription#removeFileFromChatbot" data-index="${index}">
            <i class="fa fa-times"></i>
          </button>
        `;
      }
      
      previewList.appendChild(fileItem);
    });
  }

  removeFileFromChatbot(event) {
    const index = parseInt(event.currentTarget.dataset.index);
    this.chatbotFiles.splice(index, 1);
    this.updateChatbotFilePreview();
  }

  clearChatbotFiles(event) {
    event.preventDefault();
    this.chatbotFiles = [];
    this.updateChatbotFilePreview();
  }

  async toggleChatbotRecording(event) {
    event.preventDefault();
    const button = document.getElementById('chatbot-record-btn');
    const icon = document.getElementById('chatbot-record-icon');

    if (!this.chatbotIsRecording) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: { echoCancellation: true, noiseSuppression: true, sampleRate: 44100 }
        });

        const mimeType = MediaRecorder.isTypeSupported('audio/webm') ? 'audio/webm' : 'audio/mp4';
        this.chatbotMediaRecorder = new MediaRecorder(stream, { mimeType: mimeType });
        this.chatbotAudioChunks = [];

        this.chatbotMediaRecorder.ondataavailable = (e) => {
          this.chatbotAudioChunks.push(e.data);
        };

        this.chatbotMediaRecorder.onstop = () => {
          const ext = mimeType === 'audio/webm' ? 'webm' : 'mp4';
          const audioBlob = new Blob(this.chatbotAudioChunks, { type: mimeType });
          const audioFile = new File([audioBlob], `recording_${Date.now()}.${ext}`, { type: mimeType });

          this.chatbotFiles.push(audioFile);
          this.updateChatbotFilePreview();

          stream.getTracks().forEach(track => track.stop());
          this.chatbotMediaRecorder = null;
          this.chatbotAudioChunks = [];
        };

        this.chatbotMediaRecorder.start();
        this.chatbotIsRecording = true;

        button.classList.add('recording');
        icon.classList.remove('fa-microphone');
        icon.classList.add('fa-stop');
      } catch (err) {
        console.error('Chatbot mic error:', err);
        if (err.name === 'NotAllowedError') {
          flashToast('Microphone access was denied. Please enable it in browser settings.', 'warning');
        } else if (err.name === 'NotFoundError') {
          flashToast('No microphone found. Please connect a microphone.', 'warning');
        } else {
          flashToast('Error accessing microphone: ' + err.message, 'warning');
        }
      }
    } else {
      if (this.chatbotMediaRecorder && this.chatbotMediaRecorder.state !== 'inactive') {
        this.chatbotMediaRecorder.stop();
      }
      this.chatbotIsRecording = false;

      button.classList.remove('recording');
      icon.classList.remove('fa-stop');
      icon.classList.add('fa-microphone');
    }
  }

  formatFileSize(bytes) {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  }

  // sendChatbotMessage is defined above (single unified method)

  getCurrentAppointmentId() {
    // Get the current appointment ID from the active appointment tab
    const activeTab = document.querySelector('.appointment-tabs .bg-theme');
    if (activeTab && activeTab.dataset.appointmentid) {
      return activeTab.dataset.appointmentid;
    }
    
    // Fallback to URL params
    const urlParams = new URLSearchParams(window.location.search);
    const appointmentId = urlParams.get('appointment_id');
    if (appointmentId) {
      return appointmentId;
    }

    // Return empty string if not found (original behavior)
    return '';
  }

  // ─── Allied Specialist Notes ─────────────────────────────────────────
  // Loads every GenericReport for this appointment, updates the count badge,
  // and caches the payload on the button for the popup to use.
  loadAlliedNotes(appointmentId) {
    if (!appointmentId) return;
    $.ajax({
      url: `${HOST}/prescription/allied_reports?appointment_id=${appointmentId}`,
      headers: { "Authorization": `Token ${TOKEN}` },
      success: function (res) {
        const reports = (res && res.reports) || [];
        $("#allied-notes-count").text(reports.length);
        if (reports.length > 0) {
          $("#allied-notes-btn")
            .removeClass("d-none")
            .data("reports", reports)
            .data("appointmentId", appointmentId);
        } else {
          $("#allied-notes-btn").addClass("d-none");
        }
      },
      error: function () {
        $("#allied-notes-btn").addClass("d-none");
      }
    });
  }

  openAlliedNotes(event) {
    if (event) event.preventDefault();
    const reports = $("#allied-notes-btn").data("reports") || [];
    const appointmentId = $("#allied-notes-btn").data("appointmentId");
    if (reports.length === 0) return;

    const escapeHtml = (s) =>
      String(s == null ? "" : s)
        .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;").replace(/'/g, "&#039;");

    let tabsHtml = "";
    let panesHtml = "";

    reports.forEach((r, idx) => {
      const tabId = `allied-tab-${r.report_id}`;
      const activeLink = idx === 0 ? "active" : "";
      const activePane = idx === 0 ? "show active" : "";
      const sp = r.sp_type ? ` <small class="text-muted">(${escapeHtml(r.sp_type)})</small>` : "";

      tabsHtml += `
        <li class="nav-item">
          <a class="nav-link ${activeLink}" data-toggle="tab" href="#${tabId}" role="tab">
            ${escapeHtml(r.specialist_name || "Unknown")}${sp}
          </a>
        </li>`;

      const fieldsHtml = (r.fields || []).map((f) => {
        let inputHtml;
        if (f.field_type === "multi_select") {
          const selected = (f.value || "").split(",").map((s) => s.trim());
          const opts = (f.options || []).map((o) => {
            const sel = selected.includes(o) ? "selected" : "";
            return `<option value="${escapeHtml(o)}" ${sel}>${escapeHtml(o)}</option>`;
          }).join("");
          inputHtml = `<select multiple class="form-control" data-field-label="${escapeHtml(f.label)}">${opts}</select>`;
        } else {
          inputHtml = `<input type="text" class="form-control" data-field-label="${escapeHtml(f.label)}" value="${escapeHtml(f.value)}">`;
        }
        const remarksHtml = f.has_remarks
          ? `<div class="col-md-2"><input type="text" class="form-control" data-field-remarks="${escapeHtml(f.label)}" placeholder="Remarks" value="${escapeHtml(f.remarks)}"></div>`
          : "";
        return `
          <div class="row mb-2 align-items-center">
            <div class="col-md-3"><b>${escapeHtml(f.label)}</b></div>
            <div class="${f.has_remarks ? "col-md-7" : "col-md-9"}">${inputHtml}</div>
            ${remarksHtml}
          </div>`;
      }).join("");

      const fmtDate = (iso) => {
        if (!iso) return "";
        try {
          const d = new Date(iso);
          return d.toLocaleString();
        } catch (_) { return iso; }
      };

      const authoredLine = r.authored_by
        ? `Authored by <b>${escapeHtml(r.authored_by)}</b>${r.authored_at ? " on " + escapeHtml(fmtDate(r.authored_at)) : ""}`
        : "";
      const lastEditedLine = r.last_edited_by
        ? `Last edited by <b>${escapeHtml(r.last_edited_by)}</b>${r.last_edited_at ? " on " + escapeHtml(fmtDate(r.last_edited_at)) : ""}`
        : "";
      const footerHtml = (authoredLine || lastEditedLine)
        ? `<div class="text-muted small mt-2 pt-2 border-top">
             ${authoredLine ? `<div>${authoredLine}</div>` : ""}
             ${lastEditedLine ? `<div>${lastEditedLine}</div>` : ""}
           </div>`
        : "";

      panesHtml += `
        <div class="tab-pane fade ${activePane}" id="${tabId}" role="tabpanel">
          <form class="allied-report-form" data-report-id="${r.report_id}" data-appointment-id="${appointmentId}">
            ${fieldsHtml}
            <div class="row mb-3 mt-3">
              <div class="col-md-3">
                <b>Summary Note</b>
                <br><small class="text-muted">This note will appear in the AI Summary report</small>
              </div>
              <div class="col-md-9">
                <textarea data-field-summary rows="3" class="form-control">${escapeHtml(r.summary_note)}</textarea>
              </div>
            </div>
            <div class="text-right">
              <button type="button" class="btn btn-theme btn-sm" data-action="click->prescription#saveAlliedReport">Save</button>
            </div>
            ${footerHtml}
          </form>
        </div>`;
    });

    $("#alliedNotesTabs").html(tabsHtml);
    $("#alliedNotesTabContent").html(panesHtml);
    $("#alliedNotesModal").modal("show");
  }

  saveAlliedReport(event) {
    event.preventDefault();
    const $btn = $(event.currentTarget);
    const $form = $btn.closest("form.allied-report-form");
    const reportId = $form.data("reportId");
    const appointmentId = $form.data("appointmentId");

    const data = {};
    $form.find("[data-field-label]").each(function () {
      const label = $(this).data("fieldLabel");
      let value = $(this).val();
      if (Array.isArray(value)) value = value.join(",");
      (data[label] = data[label] || {}).value = value;
    });
    $form.find("[data-field-remarks]").each(function () {
      const label = $(this).data("fieldRemarks");
      (data[label] = data[label] || {}).remarks = $(this).val();
    });

    const summaryNote = $form.find("[data-field-summary]").val();
    const originalText = $btn.text();

    $btn.prop("disabled", true).text("Saving…");

    const block = this;
    $.ajax({
      url: `${HOST}/prescription/update_allied_report`,
      method: "PATCH",
      headers: { "Authorization": `Token ${TOKEN}` },
      data: {
        report_id: reportId,
        appointment_id: appointmentId,
        summary_note: summaryNote,
        data: data
      },
      success: function () {
        flashToast("Allied note saved", "success");
        $btn.text("Saved ✓");
        // Refresh the cached payload so subsequent opens reflect the new values
        block.loadAlliedNotes(appointmentId);
        setTimeout(() => $btn.prop("disabled", false).text(originalText), 1200);
      },
      error: function (xhr) {
        const msg = (xhr.responseJSON && xhr.responseJSON.error) || "Failed to save allied note";
        flashToast(msg, "warning");
        $btn.prop("disabled", false).text(originalText);
      }
    });
  }
}

// Global functions for script.js access (defined outside class to avoid reference errors)
function setupFieldChangeDetectionGlobal(row) {
  const controller = document.querySelector('[data-controller="prescription"]');
  if (controller && controller.stimulus_controller) {
    controller.stimulus_controller.setupFieldChangeDetection(row);
  } else {
    // Fallback: setup directly
    setupFieldChangeDetectionDirect(row);
  }
}

function setupFieldChangeDetectionDirect(row) {
  const descriptionField = row.querySelector('input[name="treatment_medicine[description]"]');
  const remarkField = row.querySelector('input[name="treatment_medicine[remark]"]');
  
  if (descriptionField) {
    descriptionField.addEventListener('input', (e) => {
      checkFieldModificationDirect(e.target, 'description');
    });
  }
  
  if (remarkField) {
    remarkField.addEventListener('input', (e) => {
      checkFieldModificationDirect(e.target, 'remark');
    });
  }
}

function checkFieldModificationDirect(field, fieldType) {
  const row = field.closest('tr');
  const feedbackLink = row.querySelector(`.feedback-link[data-field-type="${fieldType}"]`);
  
  if (!feedbackLink) return;
  
  const originalValue = field.getAttribute('data-original-prediction');
  const currentValue = field.value.trim();
  
  if (originalValue && currentValue && currentValue !== originalValue) {
    feedbackLink.style.display = 'inline';
    feedbackLink.tabIndex = 0; // Make tabbable when visible
  } else {
    feedbackLink.style.display = 'none';
    feedbackLink.tabIndex = -1; // Remove from tab flow when hidden
  }
}

// Expose global function for script.js
window.setupFieldChangeDetection = setupFieldChangeDetectionGlobal;

function handleSelect(id) {
  const now = new Date().toISOString();
  // Get previous entries from localStorage
  let entries = JSON.parse(localStorage.getItem("cabinEntries")) || [];
  // Check if already exists
  if (entries?.id) {
    const newEntry = { id: id, entryTime: entries?.entryTime }
    localStorage.setItem("cabinEntries", JSON.stringify(newEntry));
  } else {
    const newEntry = { id: id, entryTime: now }
    localStorage.setItem("cabinEntries", JSON.stringify(newEntry));
  }
}

function removeCabinEntry(id) {
  localStorage.removeItem('cabinEntries');
}
